export default {
  'pages.layouts.userLayout.title':
    '全球广告投放一站式服务平台',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '账户或密码错误',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '请输入用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.login.register': '注册',
  'pages.register.alreadyHaveAccount': '已有账号？立即登录',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.searchTable.createForm.newRule': '新建规则',
  'pages.searchTable.updateForm.ruleConfig': '规则配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '规则名称',
  'pages.searchTable.updateForm.ruleName.nameRules': '请输入规则名称！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '规则描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '请输入至少五个字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '请输入至少五个字符的规则描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置规则属性',
  'pages.searchTable.updateForm.object': '监控对象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '规则模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '规则类型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '设定调度周期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '开始时间',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '请选择开始时间！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '规则名称为必填项',
  'pages.searchTable.titleCallNo': '服务调用次数',
  'pages.searchTable.titleStatus': '状态',
  'pages.searchTable.nameStatus.default': '关闭',
  'pages.searchTable.nameStatus.running': '运行中',
  'pages.searchTable.nameStatus.online': '已上线',
  'pages.searchTable.nameStatus.abnormal': '异常',
  'pages.searchTable.titleUpdatedAt': '上次调度时间',
  'pages.searchTable.exception': '请输入异常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '订阅警报',
  'pages.searchTable.title': '查询表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已选择',
  'pages.searchTable.item': '项',
  'pages.searchTable.totalServiceCalls': '服务调用次数总计',
  'pages.searchTable.tenThousand': '万',
  'pages.searchTable.batchDeletion': '批量删除',
  'pages.searchTable.batchApproval': '批量审批',

  'pages.overseas.batchDelete': '批量删除',
  'pages.overseas.batchDeleteWithCount': '批量删除 ({count})',
  'pages.overseas.batchDeleteEmpty': '请先选择要删除的分流服务',
  'pages.overseas.batchDeleteConfirmTitle': '确定删除选中的 {count} 个分流服务吗？',
  'pages.overseas.batchDeleteConfirmContent': '删除后无法恢复，请确认所选服务无误。',
  'pages.overseas.confirmDelete': '删除',
  'pages.overseas.cancel': '取消',
  'pages.overseas.cancelSelection': '取消选择',
  'pages.overseas.batchDeleteSuccess': '已删除 {count} 个分流服务',
  'pages.overseas.batchDeletePartial': '已删除 {success} 个，{failed} 个删除失败',
  'pages.overseas.batchDeleteFailed': '批量删除失败',

  // Kakao页面
  'pages.kakao.title': 'Kakao服务管理',
  'pages.kakao.subtitle': '管理Kakao海外分流服务，支持多条域名和访问规则配置',
  'pages.kakao.addLink': '新增链接',
  'pages.kakao.refresh': '刷新',
  'pages.kakao.export': '导出',
  'pages.kakao.name': '名称',
  'pages.kakao.quantity': '数量',
  'pages.kakao.configured': '已配置',
  'pages.kakao.rule': '规则',
  'pages.kakao.ruleOrder': '顺序',
  'pages.kakao.ruleRandom': '随机',
  'pages.kakao.lockIP': '锁定IP',
  'pages.kakao.locked': '锁定',
  'pages.kakao.unlocked': '不锁定',
  'pages.kakao.status': '状态',
  'pages.kakao.enabled': '启用',
  'pages.kakao.disabled': '禁用',
  'pages.kakao.createdAt': '创建时间',
  'pages.kakao.actions': '操作',
  'pages.kakao.copy': '复制',
  'pages.kakao.copySuccess': '链接已复制到剪贴板',
  'pages.kakao.copyError': '复制失败',
  'pages.kakao.edit': '编辑',
  'pages.kakao.delete': '删除',
  'pages.kakao.deleteConfirm': '确定删除此项吗？',
  'pages.kakao.yes': '是',
  'pages.kakao.no': '否',
  'pages.kakao.addTitle': '新增链接',
  'pages.kakao.editTitle': '编辑链接',
  'pages.kakao.serviceName': '服务名称',
  'pages.kakao.serviceNamePlaceholder': '请输入服务名称',
  'pages.kakao.serviceNameRequired': '请输入服务名称',
  'pages.kakao.domains': '链接',
  'pages.kakao.domainsPlaceholder': '一行一条，多条请用换行分割',
  'pages.kakao.domainsRequired': '请输入至少一个链接',
  'pages.kakao.domainsInvalid': '域名格式不正确，只允许kakao.com及其子域名',
  'pages.kakao.deleteAccounts': '删除账号',
  'pages.kakao.deleteAccountsPlaceholder': '请输入要删除的链接/账号',
  'pages.kakao.deleteAccountsExtra': '此删除功能仅限手动版本,绑定工单删除无用.',
  'pages.kakao.deleteAccountsRemoved': '已删除 {count} 个账号',
  'pages.kakao.configuredCount': '已配置',
  'pages.kakao.configuredLinks': '条客服',
  'pages.kakao.accessRule': '访问规则',
  'pages.kakao.accessRulePlaceholder': '请选择访问规则',
  'pages.kakao.accessRuleRequired': '请选择访问规则',
  'pages.kakao.accessRuleOrder': '顺序',
  'pages.kakao.accessRuleRandom': '随机',
  'pages.kakao.fetchSuccess': '服务列表获取成功',
  'pages.kakao.fetchError': '获取服务列表失败',
  'pages.kakao.deleteSuccess': '删除成功',
  'pages.kakao.deleteError': '删除失败',
  'pages.kakao.updateSuccess': '更新成功',
  'pages.kakao.updateError': '更新失败',
  'pages.kakao.addSuccess': '添加成功',
  'pages.kakao.addError': '添加失败',
  'pages.kakao.exportDev': '导出功能开发中...',
  'pages.kakao.totalRecords': '共 {total} 条记录',
  'pages.kakao.duplicateRemoved': '已自动去除 {count} 条重复链接',
  'pages.kakao.trafficDataSuccess': '获取分流数据成功',
  'pages.kakao.trafficDataError': '获取分流数据失败',
  'pages.kakao.resetConfirmTitle': '确认重置',
  'pages.kakao.resetConfirmLine1': '此操作不可恢复：',
  'pages.kakao.resetConfirmLine2': '您确定清空访问记录吗？',
  'pages.kakao.resetButton': '重置数据',
  'pages.kakao.resetSuccess': '统计数据已彻底清空',
  'pages.kakao.updateLinkTitle': '编辑链接内容',
  'pages.kakao.currentContent': '当前内容',
  'pages.kakao.newLinkPlaceholder': '请输入新的链接',
  'pages.kakao.linkEmpty': '链接不能为空',
  'pages.kakao.linkUpdateSuccess': '链接内容更新成功',
  'pages.kakao.unknownError': '未知错误',
  'pages.kakao.operationFailed': '操作失败',
  'pages.kakao.remarkTitle': '设置备注',
  'pages.kakao.remarkPlaceholder': '请输入备注',
  'pages.kakao.remarkSuccess': '备注设置成功',
  'pages.kakao.dailyUV': '今日UV/昨日UV',
  'pages.kakao.dailyUVTooltip': '今日/昨日独立访客数',
  'pages.kakao.workOrderIncrease': '今日/总新增',
  'pages.kakao.batchLock': '批量锁定',
  'pages.kakao.unset': '未设置',
  'pages.kakao.stats': '访问统计',
  'pages.kakao.trafficData': '分流数据',
  'pages.kakao.interceptionConfig': '拦截配置',
  'pages.kakao.generateQr': '生成二维码',
  'pages.kakao.exportIp': '导出IP',
  'pages.kakao.recreateShortLink': '请重新创建服务以生成短链',
  'pages.kakao.copyCampaignLink': '复制投放链接',
  'pages.kakao.moreActions': '更多操作',
  'pages.kakao.shareService': '分享服务',
  'pages.kakao.searchPlaceholder': '搜索服务名称',
  'pages.kakao.workOrderManagement': '工单管理',
  'pages.kakao.favorite': '收藏',
  'pages.kakao.unfavorite': '取消收藏',
  'pages.kakao.favoriteOnly': '仅看收藏',
  'pages.kakao.favoriteSuccess': '收藏成功',
  'pages.kakao.unfavoriteSuccess': '已取消收藏',
  'pages.kakao.favoriteToggleFailed': '收藏操作失败',
  'pages.kakao.viewAll': '查看全部',
  'pages.kakao.workOrderOnly': '仅查看工单',
  'pages.kakao.batchDedupe': '批量去重',
  'pages.kakao.myIpLibrary': '我的IP库',
  'pages.kakao.lockIPTooltip':
    '开启后通过浏览器指纹+IP双条件去重，同一个人访问多次只显示一个分流客服',
  'pages.kakao.trafficStatsTitle': '分流数据统计 - {name}',
  'pages.kakao.close': '关闭',
  'pages.kakao.refreshData': '刷新数据',
  'pages.kakao.showingRecords': '显示 {filtered} / {total} 条记录',
  'pages.kakao.customerLink': '客服链接',
  'pages.kakao.workOrderIds': '绑定',
  'pages.kakao.percentage': '占比%',
  'pages.kakao.disabledManual': '禁用（手动）',
  'pages.kakao.disabledFlowOptimize': '禁用（分流优化）',
  'pages.kakao.disabledAuto': '禁用（自动）',
  'pages.kakao.disabledManualTooltip': '手动禁用的账号不会被自动同步重新启用',
  'pages.kakao.disabledFlowOptimizeTooltip':
    '账号今日添加好友达到工单阈值后被分流优化停用，仅可手动启用',
  'pages.kakao.disabledAutoTooltip': '系统自动规则触发禁用，可手动重新启用',
  'pages.kakao.setRemark': '设置备注',
  'pages.kakao.batchLockTitle': '批量锁定IP设置',
  'pages.kakao.batchLockDesc': '请选择需要共用锁定IP去重的服务',
  'pages.kakao.batchLockPlaceholder': '请输入分组名称(必填)',
  'pages.kakao.selectedServices': '已选择 {count} 个服务',
  'pages.kakao.exportSuccess': '导出成功',
  'pages.kakao.pageRange': '第 {start}-{end} 条/共 {total} 条',
  'pages.kakao.batchDedupeRequired': '请至少选择一个服务',
  'pages.kakao.batchDedupeSuccess': '成功更新 {count} 个服务',
  'pages.kakao.unbindBatchLockConfirmTitle': '确定解除当前去重绑定吗？',
  'pages.kakao.unbindBatchLockConfirmDesc': '解除后，该服务将不再属于此批量去重分组。',
  'pages.kakao.unbindBatchLockConfirmOk': '解除绑定',
  'pages.kakao.unbindBatchLockSuccess': '已解除批量去重绑定',
  'pages.kakao.deviceRouting': '设备分流',
  'pages.kakao.deviceRoutingTitle': '设备分流设置 - {name}',
  'pages.kakao.deviceRoutingSave': '保存设置',
  'pages.kakao.deviceRoutingSaveSuccess': '设备分流设置已保存',
  'pages.kakao.deviceRoutingSaveError': '保存设备分流设置失败',
  'pages.kakao.deviceRoutingNoLinks': '当前服务没有可配置的链接',
  'pages.kakao.deviceRoutingLink': '链接',
  'pages.kakao.deviceRoutingTagAll': '全部设备',
  'pages.kakao.deviceRoutingTagIOS': '仅 iOS',
  'pages.kakao.deviceRoutingTagAndroid': '仅 Android',
  'pages.kakao.requestFailed': '请求失败',
  'pages.kakao.maxDomains': '域名数量不能超过5000个',

  // Line页面
  'pages.line.title': 'Line服务管理',
  'pages.line.subtitle': '管理Line海外分流服务，支持多条域名和访问规则配置',
  'pages.line.addLink': '新增链接',
  'pages.line.refresh': '刷新',
  'pages.line.export': '导出',
  'pages.line.name': '名称',
  'pages.line.quantity': '数量',
  'pages.line.configured': '已配置',
  'pages.line.rule': '规则',
  'pages.line.ruleOrder': '顺序',
  'pages.line.ruleRandom': '随机',
  'pages.line.lockIP': '锁定IP',
  'pages.line.locked': '锁定',
  'pages.line.unlocked': '不锁定',
  'pages.line.status': '状态',
  'pages.line.enabled': '启用',
  'pages.line.disabled': '禁用',
  'pages.line.createdAt': '创建时间',
  'pages.line.actions': '操作',
  'pages.line.copy': '复制',
  'pages.line.copySuccess': '链接已复制到剪贴板',
  'pages.line.copyError': '复制失败',
  'pages.line.edit': '编辑',
  'pages.line.delete': '删除',
  'pages.line.deleteConfirm': '确定删除此项吗？',
  'pages.line.yes': '是',
  'pages.line.no': '否',
  'pages.line.addTitle': '新增链接',
  'pages.line.editTitle': '编辑链接',
  'pages.line.serviceName': '服务名称',
  'pages.line.serviceNamePlaceholder': '请输入服务名称',
  'pages.line.serviceNameRequired': '请输入服务名称',
  'pages.line.domains': '链接',
  'pages.line.domainsPlaceholder': '一行一条，多条请用换行分割',
  'pages.line.domainsRequired': '请输入至少一个链接',
  'pages.line.domainsInvalid': '域名格式不正确，只允许line.me及其子域名',
  'pages.line.deleteAccounts': '删除账号',
  'pages.line.deleteAccountsPlaceholder': '@468rqiiq（每行一个链接或账号）',
  'pages.line.deleteAccountsExtra':
    '可输入完整链接或 Line ID。输入 @账号 可删除对应的整条 oaMessage 链接；此功能仅限手动版本，绑定工单删除无用。',
  'pages.line.deleteAccountsRemoved': '已删除 {count} 个账号',
  'pages.line.configuredCount': '已配置',
  'pages.line.configuredLinks': '条客服',
  'pages.line.accessRule': '访问规则',
  'pages.line.accessRulePlaceholder': '请选择访问规则',
  'pages.line.accessRuleRequired': '请选择访问规则',
  'pages.line.accessRuleOrder': '顺序',
  'pages.line.accessRuleRandom': '随机',
  'pages.line.fetchSuccess': '服务列表获取成功',
  'pages.line.fetchError': '获取服务列表失败',
  'pages.line.deleteSuccess': '删除成功',
  'pages.line.deleteError': '删除失败',
  'pages.line.updateSuccess': '更新成功',
  'pages.line.updateError': '更新失败',
  'pages.line.addSuccess': '添加成功',
  'pages.line.addError': '添加失败',
  'pages.line.exportDev': '导出功能开发中...',
  'pages.line.totalRecords': '共 {total} 条记录',
  'pages.line.duplicateRemoved': '已自动去除 {count} 条重复链接',
  'pages.line.trafficDataSuccess': '获取分流数据成功',
  'pages.line.trafficDataError': '获取分流数据失败',
  'pages.line.resetConfirmTitle': '确认重置',
  'pages.line.resetConfirmLine1': '此操作不可恢复：',
  'pages.line.resetConfirmLine2': '您确定清空访问记录吗？',
  'pages.line.resetButton': '重置数据',
  'pages.line.resetSuccess': '统计数据已彻底清空',
  'pages.line.updateLinkTitle': '编辑链接内容',
  'pages.line.currentContent': '当前内容',
  'pages.line.newLinkPlaceholder': '请输入新的链接或ID',
  'pages.line.linkEmpty': '链接或ID不能为空',
  'pages.line.linkUpdateSuccess': '链接内容更新成功',
  'pages.line.unknownError': '未知错误',
  'pages.line.operationFailed': '操作失败',
  'pages.line.remarkTitle': '设置备注',
  'pages.line.remarkPlaceholder': '请输入备注',
  'pages.line.remarkSuccess': '备注设置成功',
  'pages.line.dailyUV': '今日UV/昨日UV',
  'pages.line.dailyUVTooltip': '今日/昨日独立访客数',
  'pages.line.workOrderIncrease': '今日/总新增',
  'pages.line.batchLock': '批量锁定',
  'pages.line.unset': '未设置',
  'pages.line.stats': '访问统计',
  'pages.line.trafficData': '分流数据',
  'pages.line.interceptionConfig': '拦截配置',
  'pages.line.generateQr': '生成二维码',
  'pages.line.exportIp': '导出IP',
  'pages.line.recreateShortLink': '请重新创建服务以生成短链',
  'pages.line.copyCampaignLink': '复制投放链接',
  'pages.line.moreActions': '更多操作',
  'pages.line.shareService': '分享服务',
  'pages.line.searchPlaceholder': '搜索名称、短码、账号、链接或备注',
  'pages.line.workOrderManagement': '工单管理',
  'pages.line.favorite': '收藏',
  'pages.line.unfavorite': '取消收藏',
  'pages.line.favoriteOnly': '仅看收藏',
  'pages.line.favoriteSuccess': '收藏成功',
  'pages.line.unfavoriteSuccess': '已取消收藏',
  'pages.line.favoriteToggleFailed': '收藏操作失败',
  'pages.line.viewAll': '查看全部',
  'pages.line.workOrderOnly': '仅查看工单',
  'pages.line.batchDedupe': '批量去重',
  'pages.line.myIpLibrary': '我的IP库',
  'pages.line.lockIPTooltip':
    '开启后通过浏览器指纹+IP双条件去重，同一个人访问多次只显示一个分流客服',
  'pages.line.trafficStatsTitle': '分流数据统计 - {name}',
  'pages.line.close': '关闭',
  'pages.line.refreshData': '刷新数据',
  'pages.line.showingRecords': '显示 {filtered} / {total} 条记录',
  'pages.line.customerLink': '客服链接',
  'pages.line.workOrderIds': '绑定',
  'pages.line.percentage': '占比%',
  'pages.line.disabledManual': '禁用（手动）',
  'pages.line.disabledFlowOptimize': '禁用（分流优化）',
  'pages.line.disabledAuto': '禁用（自动）',
  'pages.line.disabledManualTooltip': '手动禁用的账号不会被自动同步重新启用',
  'pages.line.disabledFlowOptimizeTooltip':
    '账号今日添加好友达到工单阈值后被分流优化停用，仅可手动启用',
  'pages.line.disabledAutoTooltip': '系统自动规则触发禁用，可手动重新启用',
  'pages.line.setRemark': '设置备注',
  'pages.line.batchLockTitle': '批量锁定IP设置',
  'pages.line.batchLockDesc': '请选择需要共用锁定IP去重的服务',
  'pages.line.batchLockPlaceholder': '请输入分组名称(必填)',
  'pages.line.selectedServices': '已选择 {count} 个服务',
  'pages.line.exportSuccess': '导出成功',
  'pages.line.pageRange': '第 {start}-{end} 条/共 {total} 条',
  'pages.line.batchDedupeRequired': '请至少选择一个服务',
  'pages.line.batchDedupeSuccess': '成功更新 {count} 个服务',
  'pages.line.unbindBatchLockConfirmTitle': '确定解除当前去重绑定吗？',
  'pages.line.unbindBatchLockConfirmDesc': '解除后，该服务将不再属于此批量去重分组。',
  'pages.line.unbindBatchLockConfirmOk': '解除绑定',
  'pages.line.unbindBatchLockSuccess': '已解除批量去重绑定',
  'pages.line.deviceRouting': '设备分流',
  'pages.line.deviceRoutingTitle': '设备分流设置 - {name}',
  'pages.line.deviceRoutingSave': '保存设置',
  'pages.line.deviceRoutingSaveSuccess': '设备分流设置已保存',
  'pages.line.deviceRoutingSaveError': '保存设备分流设置失败',
  'pages.line.deviceRoutingNoLinks': '当前服务没有可配置的链接',
  'pages.line.deviceRoutingLink': '链接',
  'pages.line.deviceRoutingTagAll': '全部设备',
  'pages.line.deviceRoutingTagIOS': '仅 iOS',
  'pages.line.deviceRoutingTagAndroid': '仅 Android',
  'pages.line.requestFailed': '请求失败',
  'pages.line.maxDomains': '配置数量不能超过5000个',
  'pages.line.idRequired': '请输入至少一个Line ID',
  'pages.line.idLabel': 'Line ID',
  'pages.line.redirectType': '跳转类型',
  'pages.line.redirectTypeRequired': '请选择跳转类型',
  'pages.line.redirectTypePlaceholder': '请选择跳转类型',
  'pages.line.redirectLink': '链接跳转',
  'pages.line.redirectId': 'Line ID',
  'pages.line.idPlaceholder': '一行一条LineID',
  'pages.line.idLengthInvalid': 'Line ID长度必须在4-20位之间: {value}',
  'pages.line.idFormatInvalid':
    'Line ID格式不正确，只能包含开头@、字母、数字、点、下划线和连字符: {value}',
  'pages.line.linkFormatInvalid': '链接格式不正确，只允许 line官方域名格式: {value}',

  // Telegram页面
  'pages.tg.title': 'Telegram分流管理',
  'pages.tg.subtitle': 'Telegram分流管理',
  'pages.tg.addLink': '新建服务',
  'pages.tg.refresh': '刷新',
  'pages.tg.name': '名称',
  'pages.tg.quantity': '数量',
  'pages.tg.rule': '访问规则',
  'pages.tg.ruleOrder': '顺序',
  'pages.tg.ruleRandom': '随机',
  'pages.tg.lockIP': 'IP锁定',
  'pages.tg.locked': '已锁定',
  'pages.tg.unlocked': '未锁定',
  'pages.tg.status': '状态',
  'pages.tg.enabled': '启用',
  'pages.tg.disabled': '禁用',
  'pages.tg.createdAt': '创建时间',
  'pages.tg.actions': '操作',
  'pages.tg.copySuccess': '复制成功',
  'pages.tg.copyError': '复制失败',
  'pages.tg.edit': '编辑',
  'pages.tg.delete': '删除',
  'pages.tg.deleteConfirm': '确定要删除这个服务吗？',
  'pages.tg.addTitle': '新建服务',
  'pages.tg.editTitle': '编辑服务',
  'pages.tg.serviceName': '服务名称',
  'pages.tg.serviceNamePlaceholder': '请输入服务名称',
  'pages.tg.serviceNameRequired': '请输入服务名称',
  'pages.tg.fetchSuccess': '获取TG服务列表成功',
  'pages.tg.fetchError': '获取失败',
  'pages.tg.deleteSuccess': '删除成功',
  'pages.tg.deleteError': '删除失败',
  'pages.tg.updateSuccess': '更新成功',
  'pages.tg.updateError': '更新失败',
  'pages.tg.addSuccess': '创建成功',
  'pages.tg.addError': '创建失败',
  'pages.tg.duplicateRemoved': '已自动去除 {count} 个重复项',
  'pages.tg.deleteAccounts': '删除账号',
  'pages.tg.deleteAccountsPlaceholder': '请输入要删除的链接/账号',
  'pages.tg.deleteAccountsExtra': '此删除功能仅限手动版本,绑定工单删除无用.',
  'pages.tg.deleteAccountsRemoved': '已删除 {count} 个账号',
  'pages.tg.totalRecords': '共 {total} 条',
  'pages.tg.trafficDataSuccess': '获取分流数据成功',
  'pages.tg.trafficDataError': '获取分流数据失败',
  'pages.tg.resetConfirmTitle': '确认重置',
  'pages.tg.resetConfirmLine1': '此操作不可恢复：',
  'pages.tg.resetConfirmLine2': '您确定清空访问记录吗？',
  'pages.tg.resetButton': '重置数据',
  'pages.tg.resetSuccess': '统计数据已彻底清空',
  'pages.tg.updateLinkTitle': '编辑链接内容',
  'pages.tg.currentContent': '当前内容',
  'pages.tg.newLinkPlaceholder': '请输入新的链接或用户名',
  'pages.tg.linkEmpty': '链接或用户名不能为空',
  'pages.tg.linkUpdateSuccess': '链接内容更新成功',
  'pages.tg.unknownError': '未知错误',
  'pages.tg.operationFailed': '操作失败',
  'pages.tg.remarkTitle': '设置备注',
  'pages.tg.remarkPlaceholder': '请输入备注',
  'pages.tg.remarkSuccess': '备注设置成功',
  'pages.tg.dailyUV': '今日UV/昨日UV',
  'pages.tg.dailyUVTooltip': '今日/昨日独立访客数',
  'pages.tg.workOrderIncrease': '今日/总新增',
  'pages.tg.batchLock': '批量锁定',
  'pages.tg.unset': '未设置',
  'pages.tg.stats': '访问统计',
  'pages.tg.trafficData': '分流数据',
  'pages.tg.interceptionConfig': '拦截配置',
  'pages.tg.generateQr': '生成二维码',
  'pages.tg.exportIp': '导出IP',
  'pages.tg.recreateShortLink': '请重新创建服务以生成短链',
  'pages.tg.copyCampaignLink': '复制投放链接',
  'pages.tg.moreActions': '更多操作',
  'pages.tg.shareService': '分享服务',
  'pages.tg.searchPlaceholder': '搜索名称、短码、账号、链接或备注',
  'pages.tg.workOrderManagement': '工单管理',
  'pages.tg.favorite': '收藏',
  'pages.tg.unfavorite': '取消收藏',
  'pages.tg.favoriteOnly': '仅看收藏',
  'pages.tg.favoriteSuccess': '收藏成功',
  'pages.tg.unfavoriteSuccess': '已取消收藏',
  'pages.tg.favoriteToggleFailed': '收藏操作失败',
  'pages.tg.viewAll': '查看全部',
  'pages.tg.workOrderOnly': '仅查看工单',
  'pages.tg.batchDedupe': '批量去重',
  'pages.tg.myIpLibrary': '我的IP库',
  'pages.tg.lockIPTooltip':
    '开启后通过浏览器指纹+IP双条件去重，同一个人访问多次只显示一个分流客服',
  'pages.tg.trafficStatsTitle': '分流数据统计 - {name}',
  'pages.tg.close': '关闭',
  'pages.tg.refreshData': '刷新数据',
  'pages.tg.showingRecords': '显示 {filtered} / {total} 条记录',
  'pages.tg.customerLink': '客服链接',
  'pages.tg.workOrderIds': '绑定',
  'pages.tg.percentage': '占比%',
  'pages.tg.disabledManual': '禁用（手动）',
  'pages.tg.disabledFlowOptimize': '禁用（分流优化）',
  'pages.tg.disabledAuto': '禁用（自动）',
  'pages.tg.disabledManualTooltip': '手动禁用的账号不会被自动同步重新启用',
  'pages.tg.disabledFlowOptimizeTooltip':
    '账号今日添加好友达到工单阈值后被分流优化停用，仅可手动启用',
  'pages.tg.disabledAutoTooltip': '系统自动规则触发禁用，可手动重新启用',
  'pages.tg.setRemark': '设置备注',
  'pages.tg.batchLockTitle': '批量锁定IP设置',
  'pages.tg.batchLockDesc': '请选择需要共用锁定IP去重的服务',
  'pages.tg.batchLockPlaceholder': '请输入分组名称(必填)',
  'pages.tg.selectedServices': '已选择 {count} 个服务',
  'pages.tg.exportSuccess': '导出成功',
  'pages.tg.pageRange': '第 {start}-{end} 条/共 {total} 条',
  'pages.tg.batchDedupeRequired': '请至少选择一个服务',
  'pages.tg.batchDedupeSuccess': '成功更新 {count} 个服务',
  'pages.tg.unbindBatchLockConfirmTitle': '确定解除当前去重绑定吗？',
  'pages.tg.unbindBatchLockConfirmDesc': '解除后，该服务将不再属于此批量去重分组。',
  'pages.tg.unbindBatchLockConfirmOk': '解除绑定',
  'pages.tg.unbindBatchLockSuccess': '已解除批量去重绑定',
  'pages.tg.deviceRouting': '设备分流',
  'pages.tg.deviceRoutingTitle': '设备分流设置 - {name}',
  'pages.tg.deviceRoutingSave': '保存设置',
  'pages.tg.deviceRoutingSaveSuccess': '设备分流设置已保存',
  'pages.tg.deviceRoutingSaveError': '保存设备分流设置失败',
  'pages.tg.deviceRoutingNoLinks': '当前服务没有可配置的链接',
  'pages.tg.deviceRoutingLink': '链接',
  'pages.tg.deviceRoutingTagAll': '全部设备',
  'pages.tg.deviceRoutingTagIOS': '仅 iOS',
  'pages.tg.deviceRoutingTagAndroid': '仅 Android',
  'pages.tg.requestFailed': '请求失败',
  'pages.tg.maxDomains': '配置数量不能超过5000个',
  'pages.tg.redirectType': '跳转类型',
  'pages.tg.urlMode': '跳转入口',
  'pages.tg.redirectTypeRequired': '请选择跳转类型',
  'pages.tg.redirectTypePlaceholder': '请选择跳转类型',
  'pages.tg.redirectLink': 'Link',
  'pages.tg.redirectId': 'ID',
  'pages.tg.accessRuleRequired': '请选择访问规则',
  'pages.tg.accessRulePlaceholder': '请选择访问规则',
  'pages.tg.accessRuleOrder': '顺序',
  'pages.tg.accessRuleRandom': '随机',
  'pages.tg.domainsLabel': 'Telegram Link',
  'pages.tg.usernameLabel': 'Telegram ID',
  'pages.tg.domainsRequired': '请输入至少一个Telegram Link',
  'pages.tg.usernameRequired': '请输入至少一个Telegram ID',
  'pages.tg.configured': '已配置 {count} 个',
  'pages.tg.usernamePlaceholder':
    '一行一个Telegram ID，如：username1\\nusername2\\nusername3',
  'pages.tg.domainsPlaceholder':
    '一行一个Telegram Link，如：\\nhttps://t.me/username1\\nhttps://t.me/username2',
  'pages.tg.usernameInvalid':
    'Telegram ID格式不正确(5-32位字母/数字/下划线，可带+号): {value}',
  'pages.tg.domainsInvalid':
    'Link格式不正确，只允许 Telegram官方域名格式: {value}',

  // WhatsApp页面
  'pages.whatsapp.title': 'WhatsApp服务管理',
  'pages.whatsapp.subtitle':
    '管理WhatsApp海外分流服务，支持多条域名和访问规则配置',
  'pages.whatsapp.addLink': '新增服务',
  'pages.whatsapp.importPhone': '导入号码',
  'pages.whatsapp.importPhoneTitle': '导入号码',
  'pages.whatsapp.importPhoneConfirm': '确认导入',
  'pages.whatsapp.importPhoneUploadText': '选择或拖入 TXT 文件',
  'pages.whatsapp.importPhoneUploadHint':
    '请上传.txt文件,格式=号码 空格 备注 (备注可不填,例子:8613800001111 投手01)',
  'pages.whatsapp.importPhoneFileRequired': '请先选择 TXT 文件',
  'pages.whatsapp.importPhoneFileTypeError': '只能导入 .txt 文本文件',
  'pages.whatsapp.importPhoneFileSizeError': '文件不能超过 512KB',
  'pages.whatsapp.importPhoneInvalidLines':
    '导入格式不正确，请检查第 {lines} 行',
  'pages.whatsapp.importPhoneNoValidRows': '没有解析到有效号码',
  'pages.whatsapp.importPhoneTooManyRows': '单次最多导入 {count} 个号码',
  'pages.whatsapp.importPhoneSuccess':
    '已导入 {count} 个号码并创建服务，自动跳过 {duplicate} 条重复号码',
  'pages.whatsapp.importPhoneError': '导入失败',
  'pages.whatsapp.importPhoneServiceNamePrefix': '导入号码',
  'pages.whatsapp.refresh': '刷新',
  'pages.whatsapp.export': '导出',
  'pages.whatsapp.name': '名称',
  'pages.whatsapp.configured': '已配置',
  'pages.whatsapp.rule': '规则',
  'pages.whatsapp.ruleOrder': '顺序',
  'pages.whatsapp.ruleRandom': '随机',
  'pages.whatsapp.lockIP': '锁定IP',
  'pages.whatsapp.locked': '锁定',
  'pages.whatsapp.unlocked': '不锁定',
  'pages.whatsapp.status': '状态',
  'pages.whatsapp.enabled': '启用',
  'pages.whatsapp.disabled': '禁用',
  'pages.whatsapp.createdAt': '创建时间',
  'pages.whatsapp.actions': '操作',
  'pages.whatsapp.copy': '复制',
  'pages.whatsapp.copySuccess': '链接已复制到剪贴板',
  'pages.whatsapp.copyError': '复制失败',
  'pages.whatsapp.edit': '编辑',
  'pages.whatsapp.delete': '删除',
  'pages.whatsapp.deleteConfirm': '确定删除此项吗？',
  'pages.whatsapp.yes': '是',
  'pages.whatsapp.no': '否',
  'pages.whatsapp.addTitle': '新增服务',
  'pages.whatsapp.editTitle': '编辑服务',
  'pages.whatsapp.serviceName': '服务名称',
  'pages.whatsapp.quantity': '数量',
  'pages.whatsapp.serviceNamePlaceholder': '请输入服务名称',
  'pages.whatsapp.serviceNameRequired': '请输入服务名称',
  'pages.whatsapp.domains': '客服链接',
  'pages.whatsapp.domainsPlaceholder': '一行一条，多条请用换行分割',
  'pages.whatsapp.domainsRequired': '请输入至少一个客服链接',
  'pages.whatsapp.domainsInvalid': '链接格式不正确，只允许whatsapp官方域名格式',
  'pages.whatsapp.deleteAccounts': '删除账号',
  'pages.whatsapp.deleteAccountsPlaceholder': '请输入要删除的链接/账号',
  'pages.whatsapp.deleteAccountsExtra': '此删除功能仅限手动版本,绑定工单删除无用.',
  'pages.whatsapp.deleteAccountsRemoved': '已删除 {count} 个账号',
  'pages.whatsapp.configuredCount': '已配置',
  'pages.whatsapp.configuredLinks': '条客服',
  'pages.whatsapp.accessRule': '访问规则',
  'pages.whatsapp.accessRulePlaceholder': '请选择访问规则',
  'pages.whatsapp.accessRuleRequired': '请选择访问规则',
  'pages.whatsapp.accessRuleOrder': '顺序',
  'pages.whatsapp.accessRuleRandom': '随机',
  'pages.whatsapp.fetchSuccess': '服务列表获取成功',
  'pages.whatsapp.fetchError': '获取服务列表失败',
  'pages.whatsapp.deleteSuccess': '删除成功',
  'pages.whatsapp.deleteError': '删除失败',
  'pages.whatsapp.updateSuccess': '更新成功',
  'pages.whatsapp.updateError': '更新失败',
  'pages.whatsapp.addSuccess': '添加成功',
  'pages.whatsapp.addError': '添加失败',
  'pages.whatsapp.exportDev': '导出功能开发中...',
  'pages.whatsapp.totalRecords': '共 {total} 条记录',
  'pages.whatsapp.duplicateRemoved': '已自动去除 {count} 条重复链接',
  'pages.whatsapp.unknownError': '未知错误',
  'pages.whatsapp.operationFailed': '操作失败',
  'pages.whatsapp.trafficDataSuccess': '获取分流数据成功',
  'pages.whatsapp.trafficDataError': '获取分流数据失败',
  'pages.whatsapp.resetConfirmTitle': '确认重置',
  'pages.whatsapp.resetConfirmLine1': '此操作不可恢复：',
  'pages.whatsapp.resetConfirmLine2': '您确定清空访问记录吗?',
  'pages.whatsapp.resetButton': '重置数据',
  'pages.whatsapp.resetSuccess': '统计数据已彻底清空',
  'pages.whatsapp.dailyUV': '今日UV/昨日UV',
  'pages.whatsapp.dailyUVTooltip': '今日/昨日独立访客数',
  'pages.whatsapp.workOrderIncrease': '今日/总新增',
  'pages.whatsapp.batchLock': '批量锁定',
  'pages.whatsapp.unset': '未设置',
  'pages.whatsapp.stats': '访问统计',
  'pages.whatsapp.trafficData': '分流数据',
  'pages.whatsapp.interceptionConfig': '拦截配置',
  'pages.whatsapp.generateQr': '生成二维码',
  'pages.whatsapp.exportIp': '导出IP',
  'pages.whatsapp.recreateShortLink': '请重新创建服务以生成短链',
  'pages.whatsapp.copyCampaignLink': '复制投放链接',
  'pages.whatsapp.moreActions': '更多操作',
  'pages.whatsapp.shareService': '分享服务',
  'pages.whatsapp.fbIOSFix': 'FB 唤起修复',
  'pages.whatsapp.fbIOSFixTitle': 'FB 唤起修复 - {name}',
  'pages.whatsapp.fbIOSFixReason':
    '部分 iPhone 用户在 Facebook App 内置浏览器中点击 WhatsApp 链接时，可能被 Facebook 拦截外部 App 唤起，并误提示未安装 WhatsApp。',
  'pages.whatsapp.fbIOSFixScope':
    '开启后，仅当访问环境命中 iPhone + Facebook 内置浏览器 + WhatsApp 跳转时展示中转页，其它浏览器和 Android 仍保持原跳转流程。',
  'pages.whatsapp.fbIOSFixNotice': '落地页按钮+分流模式不需要开启此功能!!!',
  'pages.whatsapp.fbIOSFixEnableLabel': '启用 FB iOS 唤起修复',
  'pages.whatsapp.fbIOSFixEnableSuccess': 'FB iOS 唤起修复已开启',
  'pages.whatsapp.fbIOSFixDisableSuccess': 'FB iOS 唤起修复已关闭',
  'pages.whatsapp.fbIOSFixUpdateError': '保存 FB iOS 唤起修复失败',
  'pages.whatsapp.favorite': '收藏',
  'pages.whatsapp.unfavorite': '取消收藏',
  'pages.whatsapp.favoriteOnly': '仅看收藏',
  'pages.whatsapp.favoriteSuccess': '收藏成功',
  'pages.whatsapp.unfavoriteSuccess': '已取消收藏',
  'pages.whatsapp.favoriteToggleFailed': '收藏操作失败',
  'pages.whatsapp.searchPlaceholder': '搜索名称、短码、账号、链接或备注',
  'pages.whatsapp.workOrderManagement': '工单管理',
  'pages.whatsapp.viewAll': '查看全部',
  'pages.whatsapp.workOrderOnly': '仅查看工单',
  'pages.whatsapp.batchDedupe': '批量去重',
  'pages.whatsapp.myIpLibrary': '我的IP库',
  'pages.whatsapp.lockIPTooltip':
    '开启后通过浏览器指纹+IP双条件去重，同一个人访问多次只显示一个分流客服',
  'pages.whatsapp.trafficStatsTitle': '分流数据统计 - {name}',
  'pages.whatsapp.close': '关闭',
  'pages.whatsapp.refreshData': '刷新数据',
  'pages.whatsapp.showingRecords': '显示 {filtered} / {total} 条记录',
  'pages.whatsapp.customerLink': '客服链接',
  'pages.whatsapp.workOrderIds': '绑定',
  'pages.whatsapp.percentage': '占比%',
  'pages.whatsapp.disabledManual': '禁用（手动）',
  'pages.whatsapp.disabledFlowOptimize': '禁用（分流优化）',
  'pages.whatsapp.disabledAuto': '禁用（自动）',
  'pages.whatsapp.disabledManualTooltip': '手动禁用的账号不会被自动同步重新启用',
  'pages.whatsapp.disabledFlowOptimizeTooltip':
    '账号今日添加好友达到工单阈值后被分流优化停用，仅可手动启用',
  'pages.whatsapp.disabledAutoTooltip': '系统自动规则触发禁用，可手动重新启用',
  'pages.whatsapp.remarkTitle': '设置备注',
  'pages.whatsapp.remarkPlaceholder': '请输入备注',
  'pages.whatsapp.remarkSuccess': '备注设置成功',
  'pages.whatsapp.setRemark': '设置备注',
  'pages.whatsapp.pageRange': '第 {start}-{end} 条/共 {total} 条',
  'pages.whatsapp.exportSuccess': '导出成功',
  'pages.whatsapp.batchLockTitle': '批量锁定IP设置',
  'pages.whatsapp.batchLockDesc': '请选择需要共用锁定IP去重的服务',
  'pages.whatsapp.batchLockPlaceholder': '请输入分组名称(必填)',
  'pages.whatsapp.batchLockConfirm': '确认设置',
  'pages.whatsapp.selectedServices': '已选择 {count} 个服务',
  'pages.whatsapp.batchDedupeRequired': '请至少选择2个服务进行去重',
  'pages.whatsapp.batchDedupeSuccess': '已将 {count} 个服务设置为同一去重组',
  'pages.whatsapp.batchDedupeError': '设置失败',
  'pages.whatsapp.unbindBatchLockConfirmTitle': '确定解除当前去重绑定吗？',
  'pages.whatsapp.unbindBatchLockConfirmDesc': '解除后，该服务将不再属于此批量去重分组。',
  'pages.whatsapp.unbindBatchLockConfirmOk': '解除绑定',
  'pages.whatsapp.unbindBatchLockSuccess': '已解除批量去重绑定',
  'pages.whatsapp.deviceRouting': '设备分流',
  'pages.whatsapp.deviceRoutingTitle': '设备分流设置 - {name}',
  'pages.whatsapp.deviceRoutingSave': '保存设置',
  'pages.whatsapp.deviceRoutingSaveSuccess': '设备分流设置已保存',
  'pages.whatsapp.deviceRoutingSaveError': '保存设备分流设置失败',
  'pages.whatsapp.deviceRoutingNoLinks': '当前服务没有可配置的链接',
  'pages.whatsapp.deviceRoutingLink': '链接',
  'pages.whatsapp.deviceRoutingTagAll': '全部设备',
  'pages.whatsapp.deviceRoutingTagIOS': '仅 iOS',
  'pages.whatsapp.deviceRoutingTagAndroid': '仅 Android',
  'pages.whatsapp.domainOrPhoneRequired': '请输入至少一个手机号或客服链接',
  'pages.whatsapp.phoneLabel': '手机号',
  'pages.whatsapp.phoneHint': '输入国际区号和号码,无需输入+号.例子:8613900000000',
  'pages.whatsapp.phoneRequired': '请输入至少一个手机号',
  'pages.whatsapp.phoneInvalid': '手机号格式不正确，只允许纯数字: {value}',
  'pages.whatsapp.domainsInvalidDetailed':
    '链接格式不正确，只允许 whatsapp官方域名或 wa.me 格式: {value}',
  'pages.whatsapp.redirectType': '跳转类型',
  'pages.whatsapp.redirectTypeRequired': '请选择跳转类型',
  'pages.whatsapp.redirectTypePlaceholder': '请选择跳转类型',
  'pages.whatsapp.redirectPhone': '手机号',
  'pages.whatsapp.redirectLink': '链接跳转',
  'pages.whatsapp.greetingMode': '问候语模式',
  'pages.whatsapp.greetingModeSingle': '单条问候语',
  'pages.whatsapp.greetingModeBatch': '批量问候语',
  'pages.whatsapp.singleGreetingLabel': '单条问候语',
  'pages.whatsapp.singleGreetingExtra':
    '访问时会自动添加此问候语到 WhatsApp 消息中',
  'pages.whatsapp.singleGreetingPlaceholder':
    '请输入问候语，如：你好，我想咨询一下。',
  'pages.whatsapp.batchGreetingLabel': '批量问候语',
  'pages.whatsapp.batchGreetingLimit': '最多支持 {max} 条，空行不计数。',
  'pages.whatsapp.batchGreetingCount': '{count} / {max} 条',
  'pages.diversion.greetingLineLimit': '最多支持 {max} 行，空行不计数。',
  'pages.diversion.greetingLineCount': '{count} / {max} 行',
  'pages.whatsapp.batchGreetingExtra':
    '一行一条，多条请用换行分割，系统会轮询使用',
  'pages.whatsapp.batchGreetingPlaceholder':
    '你好，我想咨询一下。\\n请问有什么可以帮助您的吗？\\n欢迎咨询我们的服务！',
  'pages.whatsapp.submitUpdate': '更新',
  'pages.whatsapp.submitCreate': '创建',
  'pages.whatsapp.cancel': '取消',
  'pages.whatsapp.rulePriority': '优先级',
  'pages.whatsapp.enableSuccess': '启用成功',
  'pages.whatsapp.disableSuccess': '禁用成功',
  'pages.whatsapp.updateLinkTitle': '编辑链接内容',
  'pages.whatsapp.linkOrPhone': '链接或手机号',
  'pages.whatsapp.linkEmpty': '链接或手机号不能为空',
  'pages.whatsapp.newLinkPlaceholder': '请输入新的链接或手机号',
  'pages.whatsapp.priorityRouting': '优先级分流',
  'pages.whatsapp.thresholdLabel': 'UV阈值',
  'pages.whatsapp.thresholdTooltip':
    '阈值是独立访客，然后会有5%-20%的上下浮动。',
  'pages.whatsapp.thresholdRequired': '请输入UV阈值',
  'pages.whatsapp.thresholdRange': '阈值范围为 1-10000',
  'pages.whatsapp.linkUpdateFailed': '链接更新失败',
  'pages.whatsapp.editSuccess': '编辑成功',

  // Custom pages
  'pages.custom.title': '自定义分流管理',
  'pages.custom.subtitle': '管理自定义域名分流服务，支持多条域名和访问规则配置',
  'pages.custom.addService': '新增服务',
  'pages.custom.refresh': '刷新',
  'pages.custom.interceptionConfig': '拦截配置',
  'pages.custom.batchDedupe': '批量去重',
  'pages.custom.searchPlaceholder': '搜索服务名称',
  'pages.custom.totalRecords': '共 {total} 条记录',
  'pages.custom.addTitle': '新增服务',
  'pages.custom.editTitle': '编辑服务',
  'pages.custom.serviceName': '服务名称',
  'pages.custom.serviceNamePlaceholder': '请输入服务名称',
  'pages.custom.serviceNameRequired': '请输入服务名称',
  'pages.custom.serviceDescription': '服务描述',
  'pages.custom.serviceDescriptionPlaceholder': '请输入服务描述',
  'pages.custom.links': '链接',
  'pages.custom.linksExtra': '一行一条，多条请用换行分割，必须以https://开头',
  'pages.custom.domainsRequired': '请输入至少一个链接',
  'pages.custom.domainsInvalid': '链接格式不正确，必须以https://开头: {value}',
  'pages.custom.accessRule': '访问规则',
  'pages.custom.accessRulePlaceholder': '请选择访问规则',
  'pages.custom.accessRuleRequired': '请选择访问规则',
  'pages.custom.accessRuleOrder': '顺序',
  'pages.custom.accessRuleRandom': '随机',
  'pages.custom.statusSettings': '状态设置',
  'pages.custom.lockIP': '锁定IP',
  'pages.custom.lockIPTooltip':
    '开启后通过浏览器指纹+IP双条件去重，同一个人访问多次只显示一个分流客服',
  'pages.custom.status': '状态',
  'pages.custom.enabled': '启用',
  'pages.custom.disabled': '禁用',
  'pages.custom.submitUpdate': '更新',
  'pages.custom.submitCreate': '创建',
  'pages.custom.cancel': '取消',
  'pages.custom.loadError': '加载数据失败',
  'pages.custom.requestFailed': '请求失败',
  'pages.custom.updateSuccess': '更新成功',
  'pages.custom.addSuccess': '创建成功',
  'pages.custom.updateError': '更新失败',
  'pages.custom.operationFailed': '操作失败',
  'pages.custom.deleteSuccess': '删除成功',
  'pages.custom.deleteError': '删除失败',
  'pages.custom.shortCodeMissing': '短码不存在，请重新创建服务',
  'pages.custom.copySuccess': '短链已复制到剪贴板',
  'pages.custom.copyError': '复制失败',
  'pages.custom.trafficDataError': '获取分流数据失败',
  'pages.custom.enableSuccess': '启用成功',
  'pages.custom.disableSuccess': '禁用成功',
  'pages.custom.remarkTitle': '设置备注',
  'pages.custom.remarkPlaceholder': '请输入备注',
  'pages.custom.remarkSuccess': '备注设置成功',
  'pages.custom.updateLinkTitle': '编辑链接内容',
  'pages.custom.currentContent': '当前内容',
  'pages.custom.newLinkPlaceholder': '请输入新的链接',
  'pages.custom.linkEmpty': '链接不能为空',
  'pages.custom.linkUpdateSuccess': '链接内容更新成功',
  'pages.custom.unknownError': '未知错误',
  'pages.custom.resetConfirmTitle': '确认重置',
  'pages.custom.resetConfirmContent':
    '重置后将清空今日所有客服链接的UV和PV数据，此操作不可恢复。确定要继续吗？',
  'pages.custom.resetButton': '确定重置',
  'pages.custom.resetSuccess': '统计数据已重置',
  'pages.custom.name': '名称',
  'pages.custom.quantity': '数量',
  'pages.custom.description': '描述',
  'pages.custom.configured': '已配置',
  'pages.custom.configuredLinks': '{count} 条链接',
  'pages.custom.rule': '规则',
  'pages.custom.ruleOrder': '顺序',
  'pages.custom.ruleRandom': '随机',
  'pages.custom.locked': '已锁定',
  'pages.custom.unlocked': '未锁定',
  'pages.custom.batchLock': '批量锁定',
  'pages.custom.unset': '未设置',
  'pages.custom.createdAt': '创建时间',
  'pages.custom.actions': '操作',
  'pages.custom.stats': '访问统计',
  'pages.custom.trafficData': '分流数据',
  'pages.custom.generateQr': '生成二维码',
  'pages.custom.edit': '编辑',
  'pages.custom.delete': '删除',
  'pages.custom.deleteConfirm': '确认删除',
  'pages.custom.deleteConfirmContent': '确定要删除这个服务吗？',
  'pages.custom.yes': '确定',
  'pages.custom.recreateShortLink': '请重新创建服务以生成短链',
  'pages.custom.copyCampaignLink': '复制投放链接',
  'pages.custom.moreActions': '更多操作',
  'pages.custom.shareService': '分享服务',
  'pages.custom.trafficStatsTitle': '分流数据统计 - {name}',
  'pages.custom.close': '关闭',
  'pages.custom.refreshData': '刷新数据',
  'pages.custom.customerLink': '客服链接',
  'pages.custom.percentage': '占比%',
  'pages.custom.setRemark': '设置备注',
  'pages.custom.pageRange': '第 {start}-{end} 条/共 {total} 条',
  'pages.custom.batchLockTitle': '批量锁定IP设置',
  'pages.custom.batchLockDesc': '请选择需要共用锁定IP去重的服务',
  'pages.custom.batchLockPlaceholder': '请输入分组名称(必填)',
  'pages.custom.selectedServices': '已选择 {count} 个服务',
  'pages.custom.batchDedupeRequired': '请至少选择一个服务',
  'pages.custom.batchDedupeSuccess': '成功更新 {count} 个服务',

  // Service management pages
  'pages.serviceManagement.title': '服务管理',
  'pages.serviceManagement.subtitle': '统一查看和管理各平台的分流数据',
  'pages.serviceManagement.platformCustom': '自定义分流',
  'pages.serviceManagement.custom': '自定义',
  'pages.serviceManagement.selectPlatform': '选择平台',
  'pages.serviceManagement.selectPlatformPlaceholder': '请选择平台',
  'pages.serviceManagement.selectService': '选择服务',
  'pages.serviceManagement.selectServicePlaceholder': '请先选择平台',
  'pages.serviceManagement.actions': '操作',
  'pages.serviceManagement.refresh': '刷新',
  'pages.serviceManagement.autoRefresh': '自动刷新',
  'pages.serviceManagement.autoRefreshEnabled': '已开启自动刷新，间隔 {interval}',
  'pages.serviceManagement.autoRefreshSeconds': '{seconds}秒',
  'pages.serviceManagement.autoRefreshMinutes': '{minutes}分钟',
  'pages.serviceManagement.stopAutoRefresh': '关闭自动刷新',
  'pages.serviceManagement.autoRefreshStopped': '已关闭自动刷新',
  'pages.serviceManagement.resetStats': '重置统计',
  'pages.serviceManagement.noServices': '该平台暂无服务',
  'pages.serviceManagement.loadServicesError': '加载服务列表失败',
  'pages.serviceManagement.loadDataSuccess': '获取数据成功',
  'pages.serviceManagement.loadDataError': '获取数据失败',
  'pages.serviceManagement.resetConfirmTitle': '确认重置',
  'pages.serviceManagement.resetConfirmContent':
    '重置后将清空今日所有客服链接的UV和PV数据，此操作不可恢复。确定要继续吗？',
  'pages.serviceManagement.resetButton': '确定重置',
  'pages.serviceManagement.resetSuccess': '统计数据已重置',
  'pages.serviceManagement.cancel': '取消',
  'pages.serviceManagement.confirm': '确定',
  'pages.serviceManagement.unbind': '解绑',
  'pages.serviceManagement.unbindConfirmTitle': '确认解绑',
  'pages.serviceManagement.unbindConfirmContent': '确定解绑工单「{name}」与当前链接服务吗？',
  'pages.serviceManagement.unbindSuccess': '解绑成功',
  'pages.serviceManagement.unbindFailed': '解绑失败',
  'pages.serviceManagement.updateError': '更新失败',
  'pages.serviceManagement.unknownError': '未知错误',
  'pages.serviceManagement.enableSuccess': '启用成功',
  'pages.serviceManagement.disableSuccess': '禁用成功',
  'pages.serviceManagement.operationFailed': '操作失败',
  'pages.serviceManagement.priorityUpdateSuccess': '优先级更新成功',
  'pages.serviceManagement.thresholdUpdateFailed': '阈值更新失败',
  'pages.serviceManagement.remarkTitle': '设置备注',
  'pages.serviceManagement.remarkPlaceholder': '请输入备注',
  'pages.serviceManagement.remarkSuccess': '备注设置成功',
  'pages.serviceManagement.setTargetTitle': '设置目标数',
  'pages.serviceManagement.targetPlaceholder': '请输入目标数（0表示不设置）',
  'pages.serviceManagement.targetHint': '提示：此设置24小时有效，过期请重新设置。',
  'pages.serviceManagement.targetSuccess': '目标数设置成功',
  'pages.serviceManagement.updateLinkTitle': '编辑链接内容',
  'pages.serviceManagement.currentContent': '当前内容',
  'pages.serviceManagement.newLinkPlaceholder': '请输入新的链接或ID',
  'pages.serviceManagement.linkEmpty': '链接或ID不能为空',
  'pages.serviceManagement.linkUpdateSuccess': '链接内容更新成功',
  'pages.serviceManagement.boundWorkOrders': '当前绑定工单',
  'pages.serviceManagement.trafficData': '分流数据',
  'pages.serviceManagement.searchAccount': '搜索账号',
  'pages.serviceManagement.totalUV': '总UV',
  'pages.serviceManagement.totalPV': '总PV',
  'pages.serviceManagement.linksCount': '客服数',
  'pages.serviceManagement.avgUV': '平均UV',
  'pages.serviceManagement.target': '目标数',
  'pages.serviceManagement.todayIncrease': '今日新增',
  'pages.serviceManagement.totalIncrease': '总新增',
  'pages.serviceManagement.workOrderStats': '工单统计信息',
  'pages.serviceManagement.emptyTitle': '请先选择平台和服务',
  'pages.serviceManagement.emptySubtitle':
    '选择后将显示该服务的分流数据和统计信息',
  'pages.serviceManagement.customerLink': '客服链接',
  'pages.serviceManagement.priority': '优先级',
  'pages.serviceManagement.priorityHigh': '优先',
  'pages.serviceManagement.priorityNormal': '普通',
  'pages.serviceManagement.thresholdShort': 'UV阈值',
  'pages.serviceManagement.priorityProgress': '优先进度',
  'pages.serviceManagement.percentage': '占比%',
  'pages.serviceManagement.status': '状态',
  'pages.serviceManagement.enabled': '启用',
  'pages.serviceManagement.disabled': '禁用',
  'pages.serviceManagement.disabledManual': '禁用（手动）',
  'pages.serviceManagement.disabledFlowOptimize': '禁用（分流优化）',
  'pages.serviceManagement.disabledAuto': '禁用（自动）',
  'pages.serviceManagement.disabledManualTooltip':
    '手动禁用的账号不会被自动同步重新启用',
  'pages.serviceManagement.disabledFlowOptimizeTooltip':
    '账号今日添加好友达到工单阈值后被分流优化停用，仅可手动启用',
  'pages.serviceManagement.disabledAutoTooltip':
    '系统自动规则触发禁用，可手动重新启用',
  'pages.serviceManagement.remark': '备注',
  'pages.serviceManagement.setRemark': '设置备注',
  'pages.serviceManagement.edit': '编辑',
  'pages.serviceManagement.receptionSettings': '接待设置',
  'pages.serviceManagement.receptionLimit': '进线上限',
  'pages.serviceManagement.receptionUnlimited': '不限制',
  'pages.serviceManagement.receptionCurrentTotal': '工单累计进线',
  'pages.serviceManagement.receptionLimitHint':
    '按绑定工单的累计进线数量判断，达到上限后自动禁用客服号；不是从保存时重新计数。0 表示不限制，当前累计已达上限时保存后立即禁用。',
  'pages.serviceManagement.receptionEnableHint':
    '调高或取消上限不会自动启用客服号，需要手动启用。',
  'pages.serviceManagement.receptionNoWorkOrder':
    '此客服号尚未绑定工单，可先保存设置，绑定并同步工单后生效。',
  'pages.serviceManagement.receptionLimitInvalid': '请输入 0 至 2147483647 的整数',
  'pages.serviceManagement.receptionLimitBelowCurrentTotal': '设置数量小于已进线数量!',
  'pages.serviceManagement.receptionSave': '保存',
  'pages.serviceManagement.receptionSaveSuccess': '接待设置已保存',
  'pages.serviceManagement.receptionLoadError': '获取接待设置失败',
  'pages.serviceManagement.disabledReception': '接待已满',
  'pages.serviceManagement.disabledReceptionTooltip':
    '工单累计进线已达到接待上限，客服号已自动禁用。调高或取消上限后可手动启用。',
  'pages.serviceManagement.pageRange': '第 {start}-{end} 条/共 {total} 条',
  'pages.serviceManagement.workOrderLoadError': '获取工单列表失败',
  'pages.serviceManagement.workOrderStatusActive': '正常',
  'pages.serviceManagement.workOrderStatusPaused': '已暂停',
  'pages.serviceManagement.workOrderStatusError': '异常',
  'pages.serviceManagement.workOrderName': '工单名称',
  'pages.serviceManagement.platformType': '平台类型',
  'pages.serviceManagement.workOrderPlatform': '工单平台',
  'pages.serviceManagement.totalAccounts': '账号总数',
  'pages.serviceManagement.availableCount': '可用数量',
  'pages.serviceManagement.unavailableCount': '不可用数量',
  'pages.serviceManagement.lastUpdatedAt': '最后更新时间',
  'pages.serviceManagement.workOrderStatus': '工单状态',
  'pages.serviceManagement.noBoundWorkOrders': '暂无绑定的工单',
  'pages.serviceManagement.totalRecords': '共 {total} 条',

  // Stats pages
  'pages.stats.loadSuccess': '数据加载成功',
  'pages.stats.loadError': '加载失败',
  'pages.stats.date': '日期',
  'pages.stats.visitTime': '访问时间',
  'pages.stats.customerLink': '客服链接',
  'pages.stats.region': '地区',
  'pages.stats.device': '设备',
  'pages.stats.system': '系统',
  'pages.stats.model': '型号',
  'pages.stats.visitStats': '访问统计',
  'pages.stats.today': '今日',
  'pages.stats.sevenDays': '7天',
  'pages.stats.refresh': '刷新',
  'pages.stats.refreshData': '刷新数据',
  'pages.stats.close': '关闭',
  'pages.stats.syncLoading': '正在同步并加载数据...',
  'pages.stats.pageRange': '第 {start}-{end} 条/共 {total} 条',
  'pages.stats.linkSummary': '链接总计',
  'pages.stats.unknown': '未知',
  'pages.stats.mobile': '手机',
  'pages.stats.desktop': '电脑',
  'pages.stats.tablet': '平板',

  // Domain copy
  'pages.domainCopy.copy': '复制',
  'pages.domainCopy.copySuccess': '复制成功',
  'pages.domainCopy.copyFailed': '复制失败',
  'pages.domainCopy.publicDomain': '公用域名',
  'pages.domainCopy.customDomain': '自定义域名',
  'pages.domainCopy.remark': '备注',
  'pages.domainCopy.sslSuccess': 'SSL成功',
  'pages.domainCopy.sslPending': '待申请',
  'pages.domainCopy.sslFailed': 'SSL失败',

  // Interception config modal
  'pages.interception.title': '拦截配置 - {name}',
  'pages.interception.countryControl': '国家控制',
  'pages.interception.countryControlExtra':
    '启用后，只有选中国家的IP可以访问，其他国家IP将被拦截',
  'pages.interception.blockAll': '拦截全部',
  'pages.interception.blockAllExtra':
    '开启后，所有访客都会按拦截显示URL处理；适合 TikTok 即时页/广告审核期间临时跳转到审核页。',
  'pages.interception.shareRefererBlock': '分享拦截',
  'pages.interception.shareRefererBlockExtra':
    '拦截 Referer 以 android-app:// 开头的 Android App 分享或 App 内打开访问。',
  'pages.interception.enabled': '启用',
  'pages.interception.disabled': '关闭',
  'pages.interception.allowedCountries': '允许的国家',
  'pages.interception.allowedCountriesRequired': '请选择至少一个国家',
  'pages.interception.allowedCountriesPlaceholder': '请选择允许访问的国家',
  'pages.interception.countryBlock': '拦截国家',
  'pages.interception.countryBlockExtra':
    '拦截选中国家的IP；允许国家开启时以允许规则为准，不再执行此规则',
  'pages.interception.blockedCountries': '需要拦截的国家',
  'pages.interception.blockedCountriesRequired': '请选择至少一个需要拦截的国家',
  'pages.interception.blockedCountriesPlaceholder': '请选择需要拦截的国家',
  'pages.interception.chineseDetection': '中文命中',
  'pages.interception.chineseDetectionExtra':
    '检测访客浏览器语言，根据是否为中文进行拦截',
  'pages.interception.chineseDetectionMode': '中文检测模式',
  'pages.interception.chineseDetectionModeRequired': '请选择检测模式',
  'pages.interception.blockChinese': '拦截中文浏览器',
  'pages.interception.onlyAllowChinese': '仅允许中文浏览器',
  'pages.interception.displayUrl': '拦截显示URL',
  'pages.interception.displayUrlExtra': '拦截时跳转到此URL，留空则返回404',
  'pages.interception.displayUrlPlaceholder': 'https://example.com',
  'pages.interception.updateSuccess': '更新成功',
  'pages.interception.saveSuccess': '保存成功',
  'pages.interception.operationFailed': '操作失败',
  'pages.interception.linkedIpLibrary': '关联IP库：{name}',

  // Export IP modal
  'pages.exportIP.title': '导出IP',
  'pages.exportIP.confirm': '确定',
  'pages.exportIP.cancel': '取消',
  'pages.exportIP.exporting': '导出中，请稍候...',
  'pages.exportIP.infoMessage': '此功能是导出通过落地页的访问者IP数据',
  'pages.exportIP.timeRange': '时间范围',
  'pages.exportIP.timeRangeRequired': '请选择时间范围',
  'pages.exportIP.today': '今天',
  'pages.exportIP.last7Days': '近七天',
  'pages.exportIP.exportType': '导出方式',
  'pages.exportIP.exportText': '导出到文本',
  'pages.exportIP.exportLibrary': '导出到我的IP库',
  'pages.exportIP.action': '操作',
  'pages.exportIP.actionNew': '新增（创建新库）',
  'pages.exportIP.actionMerge': '合并到已有库',
  'pages.exportIP.countryRemark': '国家备注',
  'pages.exportIP.countryRemarkRequired': '请输入国家备注',
  'pages.exportIP.countryRemarkPlaceholder': '例如：美国、英国',
  'pages.exportIP.industryRemark': '行业备注',
  'pages.exportIP.industryRemarkRequired': '请输入行业备注',
  'pages.exportIP.industryRemarkPlaceholder': '例如：电商、金融',
  'pages.exportIP.selectLibrary': '选择IP库',
  'pages.exportIP.selectLibraryRequired': '请选择IP库',
  'pages.exportIP.selectLibraryPlaceholder': '请选择要合并到的IP库',
  'pages.exportIP.libraryOption': '{country} - {industry} ({count}个IP)',
  'pages.exportIP.largeDataTitle': '数据量较大',
  'pages.exportIP.largeDataContent':
    '即将导出 {count} 个IP，可能需要较长时间，是否继续？',
  'pages.exportIP.continueExport': '继续导出',
  'pages.exportIP.successText': '导出成功，共 {count} 个IP',
  'pages.exportIP.successLibrary': '导出到IP库成功，共 {count} 个IP',
  'pages.exportIP.failed': '导出失败',

  // Work order
  'pages.workOrder.requestFailedRetry': '请求失败，请重试',
  'pages.workOrder.unknownError': '发生未知错误',
  'pages.workOrder.loadOrdersFailed': '获取工单列表失败',
  'pages.workOrder.updateSuccess': '更新工单成功',
  'pages.workOrder.createSuccess': '创建工单成功',
  'pages.workOrder.operationFailed': '操作失败',
  'pages.workOrder.deleteConfirmTitle': '确认删除',
  'pages.workOrder.deleteConfirmContent': '确定要删除这个工单吗？删除后无法恢复。',
  'pages.workOrder.confirm': '确定',
  'pages.workOrder.cancel': '取消',
  'pages.workOrder.deleteSuccess': '删除成功',
  'pages.workOrder.deleteFailed': '删除失败',
  'pages.workOrder.fetchSuccessBase':
    '抓取成功！总账号数：{total}，正常：{normal}，异常：{abnormal}',
  'pages.workOrder.fetchSuccessPages': '，读取 {pages} 页',
  'pages.workOrder.fetchSuccessSample':
    '；样本[手机号:{phone} 状态:{status} 好友/群聊:{friend} 单日进粉:{daily}]',
  'pages.workOrder.fetchFailed': '抓取失败',
  'pages.workOrder.resumeSuccess': '工单已恢复运行，失败计数已重置',
  'pages.workOrder.resumeFailed': '恢复失败',
  'pages.workOrder.pauseSuccess': '工单已暂停',
  'pages.workOrder.pauseFailed': '暂停失败',
  'pages.workOrder.platformParamInvalidFetchServices':
    '平台参数缺失或格式错误，无法获取服务列表',
  'pages.workOrder.loadServicesWarning': '当前平台下没有可用服务，请先创建服务',
  'pages.workOrder.loadServicesFailed': '获取服务列表失败',
  'pages.workOrder.platformInvalidImport': '工单平台信息缺失或格式错误，无法导入',
  'pages.workOrder.selectImportService': '请选择要导入的服务',
  'pages.workOrder.importSuccessNew':
    '导入成功！服务已创建，请刷新分流管理页面查看',
  'pages.workOrder.importSuccessReplace': '导入成功！账号已替换到现有服务',
  'pages.workOrder.importSuccessMerge': '导入成功！账号已合并到现有服务',
  'pages.workOrder.importFailed': '导入失败',
  'pages.workOrder.platformMissingLoadServices': '平台信息缺失，无法加载服务列表',
  'pages.workOrder.loadCaptchaFailed': '获取验证码失败',
  'pages.workOrder.sessionExpired': '登录会话已失效，请刷新验证码后重试',
  'pages.workOrder.loginBindSuccess': '登录绑定成功',
  'pages.workOrder.loginFailed': '登录失败',
  'pages.workOrder.name': '工单名称',
  'pages.workOrder.platformType': '平台类型',
  'pages.workOrder.orderPlatform': '工单平台',
  'pages.workOrder.accountCount': '账号数量',
  'pages.workOrder.todayIncrease': '今日新增',
  'pages.workOrder.totalIncrease': '总新增',
  'pages.workOrder.lastFetch': '最后抓取',
  'pages.workOrder.orderStatus': '工单状态',
  'pages.workOrder.actions': '操作',
  'pages.workOrder.edit': '编辑',
  'pages.workOrder.pause': '暂停',
  'pages.workOrder.resume': '恢复',
  'pages.workOrder.delete': '删除',
  'pages.workOrder.resumeRunning': '恢复运行',
  'pages.workOrder.read': '读取',
  'pages.workOrder.import': '导入',
  'pages.workOrder.rebindLogin': '重绑登录',
  'pages.workOrder.loginBind': '登录绑定',
  'pages.workOrder.more': '更多',
  'pages.workOrder.title': '工单管理',
  'pages.workOrder.newOrder': '新建工单',
  'pages.workOrder.batchCreate': '批量添加',
  'pages.workOrder.totalRecords': '共 {total} 条',
  'pages.workOrder.editTitle': '编辑工单',
  'pages.workOrder.createTitle': '新建工单',
  'pages.workOrder.platformTypeRequired': '请选择平台类型',
  'pages.workOrder.orderPlatformRequired': '请选择工单平台',
  'pages.workOrder.rocketUrlNotice':
    '注：火箭工单不可直接填短链 URL，需要先在浏览器打开短链，填写最终 URL。',
  'pages.workOrder.a2cUrlNotice':
    '支持 A2C 正式分享链接（含 id）或分享列表 API 链接（含 shareCode）。API 链接可自带 password；短链请先打开并填写最终地址。',
  'pages.workOrder.whatshubShortUrlNotice':
    '支持 WhatsHub 完整工单地址（/work-order-sharing，须包含 sid 和 workId）、/m/ 分享链接或 API 链接；填写 /m/ 分享链接时请输入分享密码。',
  'pages.workOrder.whatshubShortUrlInvalid':
    '地址错误，请输入 WhatsHub 完整工单地址（/work-order-sharing，须包含 sid 和 workId）、/m/ 分享链接或 API 链接！',
  'pages.workOrder.nameRequired': '请输入工单名称',
  'pages.workOrder.namePlaceholder': '请输入工单名称',
  'pages.workOrder.link': '工单链接',
  'pages.workOrder.linkRequired': '请输入工单链接',
  'pages.workOrder.cloudLinkInvalid':
    '云控链接格式应包含 /share/share/index.html?token=xxx',
  'pages.workOrder.linkPlaceholderDefault':
    'http://47.76.114.187:61932/share/share/index.html?token=...',
  'pages.workOrder.linkPlaceholder007': '请输入 007 平台分享链接，可为任意格式',
  'pages.workOrder.linkPlaceholderSihai':
    '请输入四海营销登录页链接（默认: https://v2sotua1.7xing168.com/agent/login.html）',
  'pages.workOrder.password': '密码',
  'pages.workOrder.passwordPlaceholder007': '可选，若填写将用于登录 007 工单',
  'pages.workOrder.passwordPlaceholderScrmChampion':
    '可选，若填写将用于登录 SCRM Champion 工单',
  'pages.workOrder.passwordPlaceholderSalesmartly':
    '可选，若填写将用于登录 SaleSmartly 工单',
  'pages.workOrder.passwordPlaceholderHaiwang': '可选，若填写将用于登录海王工单',
  'pages.workOrder.passwordPlaceholderCeoscrm':
    '可选，若填写将用于登录 CEOSCRM 工单',
  'pages.workOrder.passwordPlaceholderUrl66':
    '可选，若填写将用于登录火箭url66工单',
  'pages.workOrder.passwordPlaceholderQukazhen':
    '可选，若填写将用于登录取卡针工单',
  'pages.workOrder.passwordPlaceholderChatknow':
    '可选，若填写将用于登录 Chatknow 工单',
  'pages.workOrder.passwordPlaceholderWachat':
    '可选，若填写将用于登录 WAchat 工单',
  'pages.workOrder.passwordPlaceholderXinghe':
    '可选，若填写将用于登录星河云控工单',
  'pages.workOrder.passwordPlaceholderA2c':
    '可选，API 链接已有 password 可留空；填写后优先使用此密码',
  'pages.workOrder.passwordPlaceholderUrl99':
    '可选，若填写将用于登录火箭工单',
  'pages.workOrder.advancedSettings': '高级设置',
  'pages.common.expandSettings': '展开设置',
  'pages.common.collapseSettings': '收起设置',
  'pages.workOrder.autoDisable':
    '自动禁用（自动过滤掉异常账号，避免流量浪费）',
  'pages.workOrder.autoOptimize':
    '自动优化（自动停用「有访问量但无转化」的账号，提高分流效率）',
  'pages.workOrder.minUv': '最低UV数量',
  'pages.workOrder.minUvTooltip':
    '建议广告刚开始时此设置大于10,防止AI爬虫抓取导致触发禁用',
  'pages.workOrder.minUvRequired': '请输入最低UV数量',
  'pages.workOrder.minUvPlaceholder': '默认10',
  'pages.workOrder.flowOptimize':
    '分流优化（达到今日添加好友阈值后，自动停用账号）',
  'pages.workOrder.todayAddThreshold': '今日添加好友阈值',
  'pages.workOrder.todayAddThresholdTooltip':
    '当账号今日添加好友数量达到该阈值时，系统将标记为“禁用（分流优化）”，仅可手动启用',
  'pages.workOrder.todayAddThresholdRequired': '请输入今日添加好友阈值',
  'pages.workOrder.todayAddThresholdPlaceholder': '例如 10',
  'pages.workOrder.sihaiLoginTitle': '四海营销登录绑定',
  'pages.workOrder.loginAndBind': '登录并绑定',
  'pages.workOrder.username': '账号',
  'pages.workOrder.usernameRequired': '请输入账号',
  'pages.workOrder.usernamePlaceholder': '请输入账号',
  'pages.workOrder.passwordRequired': '请输入密码',
  'pages.workOrder.passwordInputPlaceholder': '请输入密码',
  'pages.workOrder.captcha': '图形验证码',
  'pages.workOrder.captchaRequired': '请输入图形验证码',
  'pages.workOrder.captchaPlaceholder': '请输入验证码',
  'pages.workOrder.refresh': '刷新',
  'pages.workOrder.captchaAlt': '验证码',
  'pages.workOrder.captchaLoadFailed': '验证码加载失败，请点击刷新',
  'pages.workOrder.importTitle': '导入工单数据',
  'pages.workOrder.importMethod': '导入方式',
  'pages.workOrder.importMethodRequired': '请选择导入方式',
  'pages.workOrder.importModeNew': '新建服务',
  'pages.workOrder.importModeExisting': '导入到现有链接',
  'pages.workOrder.selectService': '选择服务',
  'pages.workOrder.selectServiceRequired': '请选择要导入的服务',
  'pages.workOrder.loading': '加载中...',
  'pages.workOrder.selectServicePlaceholder': '请选择服务',
  'pages.workOrder.noAvailableServices': '暂无可用服务',
  'pages.workOrder.mergeMode': '导入模式',
  'pages.workOrder.mergeModeRequired': '请选择导入模式',
  'pages.workOrder.mergeModeTooltip':
    '合并：保留现有账号，追加新账号（多工单共用同一服务）；替换：清空现有账号，导入新账号（切换工单数据）',
  'pages.workOrder.merge': '合并（追加账号）',
  'pages.workOrder.replace': '替换（清空后导入）',
  'pages.workOrder.statusSessionBound': '会话已绑定',
  'pages.workOrder.statusSessionExpired': '会话已过期',
  'pages.workOrder.statusSessionUnbound': '未绑定会话',
  'pages.workOrder.tooltipPaused': '工单已暂停',
  'pages.workOrder.statusPaused': '已暂停',
  'pages.workOrder.statusPausedWithFailures': '已暂停 (失败{count}次)',
  'pages.workOrder.tooltipFetchError': '抓取出现错误',
  'pages.workOrder.statusRunning': '正常运行',
  'pages.workOrder.statusRunningWithFailures': '运行中 (失败{count}次)',
  'pages.workOrder.source.cloud': '云控',
  'pages.workOrder.source.haiwang': '海王',
  'pages.workOrder.source.url99': '火箭',
  'pages.workOrder.source.url66': '火箭url66',
  'pages.workOrder.source.qukazhen': '取卡针',
  'pages.workOrder.source.sihai': '四海营销',
  'pages.workOrder.source.xinghe': '星河云控',
  'pages.workOrder.source.a2c': 'A2C云控',

  // Ad callback list
  'pages.adCallbackList.loadLandingPagesFailed': '加载落地页列表失败',
  'pages.adCallbackList.enabledSuccess': '已启用',
  'pages.adCallbackList.disabledSuccess': '已禁用',
  'pages.adCallbackList.operationFailed': '操作失败',
  'pages.adCallbackList.deleteSuccess': '删除成功',
  'pages.adCallbackList.deleteFailed': '删除失败',
  'pages.adCallbackList.landingPageMissing': '找不到关联的落地页',
  'pages.adCallbackList.loadLandingPageDetailFailed': '获取落地页信息失败',
  'pages.adCallbackList.domainConfigMissing': '域名配置未加载，请稍后重试',
  'pages.adCallbackList.copyLinkSuccess': '投放链接已复制到剪贴板',
  'pages.adCallbackList.unknownError': '未知错误',
  'pages.adCallbackList.configName': '配置名称',
  'pages.adCallbackList.aiLandingPage': 'AI 落地页',
  'pages.adCallbackList.landingPage': '落地页',
  'pages.adCallbackList.unknownLandingPage': '未知落地页',
  'pages.adCallbackList.eventConfig': '事件配置',
  'pages.adCallbackList.callbackConfig': '回传配置',
  'pages.adCallbackList.dedup': '去重',
  'pages.adCallbackList.on': '启用',
  'pages.adCallbackList.off': '禁用',
  'pages.adCallbackList.ratio': '比例',
  'pages.adCallbackList.successFailed': '成功/失败',
  'pages.adCallbackList.status': '状态',
  'pages.adCallbackList.actions': '操作',
  'pages.adCallbackList.copyCampaignLink': '复制投放链接',
  'pages.adCallbackList.editConfig': '编辑配置',
  'pages.adCallbackList.viewStats': '查看统计',
  'pages.adCallbackList.deleteConfig': '删除配置',
  'pages.adCallbackList.deleteConfirmTitle': '确定要删除这个配置吗？',
  'pages.adCallbackList.deleteConfirmDescription':
    '删除后将无法恢复，相关统计数据也会被清除。',
  'pages.adCallbackList.deleteConfirmShort': '确定删除此配置吗？',
  'pages.adCallbackList.confirm': '确定',
  'pages.adCallbackList.cancel': '取消',
  'pages.adCallbackList.batchDelete': '批量删除 ({count})',
  'pages.adCallbackList.cancelSelection': '取消选择',
  'pages.adCallbackList.confirmDelete': '删除',
  'pages.adCallbackList.batchDeleteConfirmTitle': '确定删除选中的 {count} 个回传配置吗？',
  'pages.adCallbackList.batchDeleteConfirmContent':
    '删除后无法恢复，相关统计数据也会被清除。',
  'pages.adCallbackList.batchDeleteSuccess': '已删除 {count} 个回传配置',
  'pages.adCallbackList.batchDeletePartial': '已删除 {success} 个，{failed} 个删除失败',
  'pages.adCallbackList.batchDeleteFailed': '批量删除失败',
  'pages.adCallbackList.createConfig': '新建配置',
  'pages.adCallbackList.searchConfigName': '搜索配置名称',
  'pages.adCallbackList.search': '搜索',
  'pages.adCallbackList.landingPageId': '落地页ID',
  'pages.adCallbackList.eventType': '事件类型',
  'pages.adCallbackList.createdAt': '创建时间',
  'pages.adCallbackList.todayClicks': '今日点击数',
  'pages.adCallbackList.stats': '统计',
  'pages.adCallbackList.usageGuide': '使用说明',
  'pages.adCallbackList.googleGuideAlt': 'Google Ads 配置说明',
  'pages.adCallbackList.googleGuideText':
    '下图展示 Google Ads 转化代码的配置位置与填写示例，可按截图示意完成设置。',
  'pages.adCallbackList.googleGuideImageNotice':
    '当前说明截图为中文后台界面，英文模式下步骤保持一致。',
  'pages.adCallbackList.tiktokTitle': 'TikTok回传配置',
  'pages.adCallbackList.tiktokSubtitle':
    '管理TikTok Events API回传配置，支持多渠道投放',
  'pages.adCallbackList.tiktokHeaderTitle': 'TikTok配置列表',
  'pages.adCallbackList.facebookTitle': 'Facebook回传配置',
  'pages.adCallbackList.facebookSubtitle':
    '管理Facebook Conversion API回传配置，支持多渠道投放',
  'pages.adCallbackList.facebookHeaderTitle': 'Facebook配置列表',
  'pages.adCallbackList.bigoTitle': 'Bigo回传配置',
  'pages.adCallbackList.bigoHeaderTitle': 'Bigo配置列表',
  'pages.adCallbackList.googleTitle': 'Google 转化追踪',
  'pages.adCallbackList.googleHeaderTitle': 'Google配置列表',

  // Ad callback stats
  'pages.adCallbackStats.loadConfigFailed': '加载配置信息失败',
  'pages.adCallbackStats.loadStatsFailed': '加载统计数据失败',
  'pages.adCallbackStats.exportSuccess': '导出成功',
  'pages.adCallbackStats.exportFailed': '导出失败',
  'pages.adCallbackStats.clearSuccess': '统计数据已清空',
  'pages.adCallbackStats.clearFailed': '清空数据失败',
  'pages.adCallbackStats.time': '时间',
  'pages.adCallbackStats.event': '事件',
  'pages.adCallbackStats.ipAddress': 'IP地址',
  'pages.adCallbackStats.pageUrl': '页面URL',
  'pages.adCallbackStats.status': '状态',
  'pages.adCallbackStats.success': '成功',
  'pages.adCallbackStats.failed': '失败',
  'pages.adCallbackStats.loading': '加载中...',
  'pages.adCallbackStats.subTitle': '路由代码: {routeCode} | 平台: {platform}',
  'pages.adCallbackStats.backToConfigs': '返回配置',
  'pages.adCallbackStats.exportData': '导出数据',
  'pages.adCallbackStats.resetData': '重置数据',
  'pages.adCallbackStats.refresh': '刷新',
  'pages.adCallbackStats.timeRange': '时间范围:',
  'pages.adCallbackStats.totalEvents': '总事件数',
  'pages.adCallbackStats.successEvents': '成功事件',
  'pages.adCallbackStats.failedEvents': '失败事件',
  'pages.adCallbackStats.successRate': '成功率',
  'pages.adCallbackStats.eventBreakdown': '事件类型分布',
  'pages.adCallbackStats.detailData': '详细数据',
  'pages.adCallbackStats.totalRecords': '共 {total} 条记录',
  'pages.adCallbackStats.tiktokTitle': 'TikTok统计 - {name}',
  'pages.adCallbackStats.facebookTitle': 'Facebook统计 - {name}',
  'pages.adCallbackStats.bigoTitle': 'Bigo统计 - {name}',
  'pages.adCallbackStats.googleTitle': 'Google统计 - {name}',
  'pages.adCallbackStats.googleSubtitle': 'Google Ads 转化追踪统计',

  // Ad callback form
  'pages.adCallbackForm.loadLandingPagesFailed': '加载落地页列表失败',
  'pages.adCallbackForm.parseLandingPageFailed': '解析落地页组件失败',
  'pages.adCallbackForm.loadLandingPageDetailFailed': '加载落地页详情失败',
  'pages.adCallbackForm.loadConfigFailed': '加载配置失败',
  'pages.adCallbackForm.createSuccess': '创建成功',
  'pages.adCallbackForm.updateSuccess': '更新成功',
  'pages.adCallbackForm.createFailed': '创建失败',
  'pages.adCallbackForm.updateFailed': '更新失败',
  'pages.adCallbackForm.operationFailed': '操作失败',
  'pages.adCallbackForm.submitFailed': '提交失败',
  'pages.adCallbackForm.back': '返回',
  'pages.adCallbackForm.backToList': '返回列表',
  'pages.adCallbackForm.cancel': '取消',
  'pages.adCallbackForm.save': '保存',
  'pages.adCallbackForm.create': '创建',
  'pages.adCallbackForm.update': '更新',
  'pages.adCallbackForm.basicConfig': '基础配置',
  'pages.adCallbackForm.callbackConfig': '回传配置',
  'pages.adCallbackForm.apiConfig': '{platform} API配置',
  'pages.adCallbackForm.configGuide': '配置说明',
  'pages.adCallbackForm.relatedLandingPage': '关联落地页',
  'pages.adCallbackForm.landingPage': '落地页',
  'pages.adCallbackForm.landingPageRequired': '请选择落地页',
  'pages.adCallbackForm.landingPagePlaceholder': '请选择落地页',
  'pages.adCallbackForm.configName': '配置名称',
  'pages.adCallbackForm.configNameRequired': '请输入配置名称',
  'pages.adCallbackForm.remark': '备注',
  'pages.adCallbackForm.remarkPlaceholder': '可选，用于记录配置用途、渠道信息等',
  'pages.adCallbackForm.optional': '选填',
  'pages.adCallbackForm.pixelId': '像素ID',
  'pages.adCallbackForm.pixelIdRequired': '请输入像素ID',
  'pages.adCallbackForm.accessToken': 'Access Token',
  'pages.adCallbackForm.accessTokenRequired': '请输入Access Token',
  'pages.adCallbackForm.eventType': '事件类型',
  'pages.adCallbackForm.eventTypeRequired': '请选择事件类型',
  'pages.adCallbackForm.eventTypePlaceholder': '请选择事件类型',
  'pages.adCallbackForm.reportEvent': '上报事件',
  'pages.adCallbackForm.defaultValue': '默认金额',
  'pages.adCallbackForm.defaultValueRequired': '请输入默认金额',
  'pages.adCallbackForm.defaultCurrency': '默认币种',
  'pages.adCallbackForm.defaultCurrencyRequired': '请选择默认币种',
  'pages.adCallbackForm.defaultCurrencyPlaceholder': '请选择币种',
  'pages.adCallbackForm.dedupIp': 'IP去重',
  'pages.adCallbackForm.enabledText': '开启',
  'pages.adCallbackForm.disabledText': '关闭',
  'pages.adCallbackForm.callbackRatio': '回传比例(%)',
  'pages.adCallbackForm.component': '组件',
  'pages.adCallbackForm.selectComponent': '选择组件',
  'pages.adCallbackForm.unnamedComponent': '未命名组件',
  'pages.adCallbackForm.jumpUrl': '跳转URL',
  'pages.adCallbackForm.enabled': '启用',
  'pages.adCallbackForm.actions': '操作',
  'pages.adCallbackForm.delete': '删除',
  'pages.adCallbackForm.jumpRuleConfigOptional': '跳转规则配置（可选）',
  'pages.adCallbackForm.jumpRuleHintTitle': '跳转规则说明',
  'pages.adCallbackForm.jumpRuleHintDescription':
    '可以为落地页中的按钮、图片等组件设置动态跳转URL，用于不同回传配置使用同一个落地页。如果不设置则默认使用落地页创建时的设置。',
  'pages.adCallbackForm.selectLandingPageFirst': '请先选择落地页',
  'pages.adCallbackForm.selectLandingPageFirstDescription':
    '选择落地页后，这里会显示该落地页的所有可用组件，您可以为其设置跳转规则。',
  'pages.adCallbackForm.noAvailableComponents': '该落地页没有可用组件',
  'pages.adCallbackForm.noAvailableComponentsDescription':
    '落地页中没有可配置跳转的组件（按钮、图片等）。',
  'pages.adCallbackForm.addJumpRule': '添加跳转规则',
  'pages.adCallbackForm.component.floatingButton': '浮动按钮',
  'pages.adCallbackForm.component.floatingButtonLabel': '浮动按钮: {text}',
  'pages.adCallbackForm.component.heroButton1Label': 'Hero按钮1: {text}',
  'pages.adCallbackForm.component.heroButton2Label': 'Hero按钮2: {text}',
  'pages.adCallbackForm.component.transparentIconLabel': '透明图标: {text}',
  'pages.adCallbackForm.component.unnamed': '未命名',
  'pages.adCallbackForm.component.styleModulePrefix': '样式模块 - ',
  'pages.adCallbackForm.component.buyButtonLabel': '购买按钮: {text}',
  'pages.adCallbackForm.component.buyNow': '立即购买',
  'pages.adCallbackForm.component.ecommercePrefix': '商品 - ',
  'pages.adCallbackForm.component.countdownPrefix': '倒计时 - ',
  'pages.adCallbackForm.component.dialogPrefix': '对话框 - ',
  'pages.adCallbackForm.component.formPrefix': '表单 - ',
  'pages.adCallbackForm.google.createTitle': '创建 Google 配置',
  'pages.adCallbackForm.google.editTitle': '编辑 Google 配置',
  'pages.adCallbackForm.google.configNamePlaceholder': '例如：WhatsApp 转化追踪',
  'pages.adCallbackForm.google.pixelCode': '像素代码',
  'pages.adCallbackForm.google.pixelCodePlaceholder':
    '粘贴 Google 像素代码（支持 Google Tag Manager、Google Analytics 等基础追踪代码）',
  'pages.adCallbackForm.google.eventCode': '事件代码',
  'pages.adCallbackForm.google.eventCodePlaceholder':
    '粘贴 Google 事件代码（转化事件追踪代码，如 Google Ads 转化代码等）',
  'pages.adCallbackForm.bigo.createTitle': '新建BigO配置',
  'pages.adCallbackForm.bigo.editTitle': '编辑BigO配置',
  'pages.adCallbackForm.bigo.introTitle': 'BigO回传说明',
  'pages.adCallbackForm.bigo.introDescription':
    '请填写BigO广告平台的像素ID和事件类型。bbg参数会自动从URL参数中读取。',
  'pages.adCallbackForm.bigo.configNamePlaceholder': '例如：美国市场-按钮点击',
  'pages.adCallbackForm.bigo.pixelIdPlaceholder': 'BigO广告像素ID',
  'pages.adCallbackForm.bigo.event.button': 'button (按钮点击)',
  'pages.adCallbackForm.bigo.event.consult': 'consult (咨询)',
  'pages.adCallbackForm.bigo.event.ec_register': 'ec_register (用户注册)',
  'pages.adCallbackForm.bigo.event.ec_add_cart': 'ec_add_cart (加入购物车)',
  'pages.adCallbackForm.bigo.event.ec_order': 'ec_order (下单)',
  'pages.adCallbackForm.bigo.event.ec_purchase': 'ec_purchase (支付完成)',
  'pages.adCallbackForm.bigo.event.form': 'form (表单填写)',
  'pages.adCallbackForm.bigo.event.phone_consult': 'phone_consult (电话咨询)',
  'pages.adCallbackForm.bigo.event.app_download': 'app_download (点击下载)',
  'pages.adCallbackForm.tiktok.createTitle': '新建TikTok配置',
  'pages.adCallbackForm.tiktok.editTitle': '编辑TikTok配置',
  'pages.adCallbackForm.tiktok.subtitle': '配置TikTok Events API回传参数和跳转规则',
  'pages.adCallbackForm.tiktok.configNamePlaceholder': '如: TikTok广告配置',
  'pages.adCallbackForm.tiktok.contentIdRule': 'Content ID 规则',
  'pages.adCallbackForm.tiktok.contentType': '内容类型',
  'pages.adCallbackForm.tiktok.contentTypeHelp': '普通回传和超级回传共用此设置；联系、线索及表单提交事件不发送商品参数。',
  'pages.adCallbackForm.tiktok.contentType.product': '单个商品（product）',
  'pages.adCallbackForm.tiktok.contentType.productGroup': '商品组（product_group）',
  'pages.adCallbackForm.tiktok.contentIdRuleTooltip':
    '触发回传时提交给TikTok的参数，不懂可以不设置，默认即可',
  'pages.adCallbackForm.tiktok.fixedContentId': '固定 Content ID',
  'pages.adCallbackForm.tiktok.fixedContentIdRequired':
    '请输入固定Content ID',
  'pages.adCallbackForm.tiktok.fixedContentIdPlaceholder':
    '固定的Content ID值',
  'pages.adCallbackForm.tiktok.guideTitle': 'TikTok API配置说明',
  'pages.adCallbackForm.tiktok.guideDescription1':
    '请在TikTok后台新建像素，并选择TikTok API回传，生成访问令牌填入Access Token。',
  'pages.adCallbackForm.tiktok.guideDescription2':
    'Content ID 规则 = 触发回传时提交给TikTok的参数，不懂可以不设置，默认即可。',
  'pages.adCallbackForm.tiktok.contentIdMode.pageId': '使用落地页ID',
  'pages.adCallbackForm.tiktok.contentIdMode.routeCode': '使用路由代码',
  'pages.adCallbackForm.tiktok.contentIdMode.fixed': '固定值',
  'pages.adCallbackForm.tiktok.event.clickButton': 'ClickButton (按钮点击)',
  'pages.adCallbackForm.tiktok.event.submitForm': 'SubmitForm (表单提交)',
  'pages.adCallbackForm.tiktok.event.contact': 'Contact (联系)',
  'pages.adCallbackForm.tiktok.event.viewContent': 'ViewContent (页面浏览)',
  'pages.adCallbackForm.tiktok.event.completeRegistration':
    'CompleteRegistration (注册完成)',
  'pages.adCallbackForm.tiktok.event.addToCart': 'AddToCart (加入购物车)',
  'pages.adCallbackForm.tiktok.event.addToWishlist': 'AddToWishlist (加入心愿单)',
  'pages.adCallbackForm.tiktok.event.initiateCheckout':
    'InitiateCheckout (开始结账)',
  'pages.adCallbackForm.tiktok.event.addPaymentInfo':
    'AddPaymentInfo (添加支付信息)',
  'pages.adCallbackForm.tiktok.event.placeAnOrder': 'PlaceAnOrder (购买下单)',
  'pages.adCallbackForm.tiktok.event.completePayment':
    'CompletePayment (完成支付)',
  'pages.adCallbackForm.tiktok.event.purchase': 'Purchase (购买完成)',
  'pages.adCallbackForm.tiktok.event.lead': 'Lead (潜在客户)',
  'pages.adCallbackForm.tiktok.event.applicationApproval':
    'ApplicationApproval (申请通过)',
  'pages.adCallbackForm.tiktok.event.customizeProduct':
    'CustomizeProduct (定制产品)',
  'pages.adCallbackForm.tiktok.event.download': 'Download (下载)',
  'pages.adCallbackForm.tiktok.event.findLocation':
    'FindLocation (查找位置)',
  'pages.adCallbackForm.tiktok.event.schedule': 'Schedule (预约)',
  'pages.adCallbackForm.tiktok.event.search': 'Search (搜索)',
  'pages.adCallbackForm.tiktok.event.startTrial': 'StartTrial (开始试用)',
  'pages.adCallbackForm.tiktok.event.submitApplication':
    'SubmitApplication (提交申请)',
  'pages.adCallbackForm.tiktok.event.subscribe': 'Subscribe (订阅)',
  'pages.adCallbackForm.facebook.createTitle': '新建Facebook配置',
  'pages.adCallbackForm.facebook.editTitle': '编辑Facebook配置',
  'pages.adCallbackForm.facebook.subtitle':
    '配置Facebook Conversion API回传参数和跳转规则',
  'pages.adCallbackForm.facebook.configNamePlaceholder':
    '如: Facebook广告配置',
  'pages.adCallbackForm.facebook.configDescriptionTitle': '配置说明',
  'pages.adCallbackForm.facebook.configDescriptionText':
    '请在Facebook后台创建Pixel，选择服务器端事件，生成访问令牌填入Access Token。',
  'pages.adCallbackForm.facebook.testEventCode': '测试事件代码（可选）',
  'pages.adCallbackForm.facebook.testEventCodeTooltip':
    '用于Facebook事件测试工具，正式环境可留空',
  'pages.adCallbackForm.facebook.testEventCodePlaceholder': '测试事件代码',
  'pages.adCallbackForm.facebook.attributionShare': '归因份额',
  'pages.adCallbackForm.facebook.attributionShareTooltip':
    '转化归因占比,默认即可',
  'pages.adCallbackForm.facebook.guideTitle':
    'Facebook Conversion API配置说明',
  'pages.adCallbackForm.facebook.guideDescription1':
    '请在Facebook后台创建手动API，选择服务器API事件，生成访问令牌填入Access Token。',
  'pages.adCallbackForm.facebook.guideDescription2':
    '测试事件代码用于Facebook事件测试工具，正式激活事件时请勿填写此字段。',
  'pages.adCallbackForm.facebook.event.pageView': 'PageView (页面浏览)',
  'pages.adCallbackForm.facebook.event.viewContent': 'ViewContent (内容查看)',
  'pages.adCallbackForm.facebook.event.addToCart': 'AddToCart (加入购物车)',
  'pages.adCallbackForm.facebook.event.addToWishlist':
    'AddToWishlist (加入心愿单)',
  'pages.adCallbackForm.facebook.event.initiateCheckout':
    'InitiateCheckout (开始结账)',
  'pages.adCallbackForm.facebook.event.purchase': 'Purchase (购买)',
  'pages.adCallbackForm.facebook.event.lead': 'Lead (潜在客户)',
  'pages.adCallbackForm.facebook.event.completeRegistration':
    'CompleteRegistration (完成注册)',
  'pages.adCallbackForm.facebook.event.contact': 'Contact (联系)',
  'pages.adCallbackForm.facebook.event.customizeProduct':
    'CustomizeProduct (自定义产品)',
  'pages.adCallbackForm.facebook.event.submitApplication':
    'SubmitApplication (提交申请)',
  'pages.adCallbackForm.facebook.event.startTrial': 'StartTrial (开始试用)',
  'pages.adCallbackForm.facebook.event.schedule': 'Schedule (预约)',
  'pages.adCallbackForm.facebook.event.subscribe': 'Subscribe (订阅)',
  'pages.adCallbackForm.facebook.event.custom': 'Custom (自定义事件)',

  // Membership alerts
  'pages.membershipAlert.loadUserInfoFailed': '获取用户信息失败',
  'pages.membershipAlert.expiringTitle': '会员即将到期',
  'pages.membershipAlert.expiringToday':
    '您的会员将于今天到期（{expiryDate}），请及时续费以继续使用服务',
  'pages.membershipAlert.expiringInDays':
    '您的会员将于 {days} 天后到期（{expiryDate}），请及时续费以继续使用服务',
  'pages.membershipAlert.lowUvTitle': 'UV余量不足',
  'pages.membershipAlert.lowUvDescription':
    '您当前套餐剩余UV低于5000，为确保投放正常进行，请进行充值。（UV不足不影响分流服务）',

  // SuperH pages
  'pages.superH.loadTikTokConfigsFailed': '加载 TikTok 配置失败，请检查网络后重试',
  'pages.superH.loadConfigFailed': '加载配置详情失败，请返回列表重试',
  'pages.superH.loadDataFailed': '加载数据失败，请稍后重试',
  'pages.superH.startSuccess': '已启动',
  'pages.superH.stopSuccess': '已停止',
  'pages.superH.operationFailed': '操作失败',
  'pages.superH.deleteSuccess': '删除成功',
  'pages.superH.deleteFailed': '删除失败',
  'pages.superH.collectSuccess':
    '收集成功：新增 {collectedCount} 个，总计 {totalCount} 个',
  'pages.superH.collectFailed': '收集失败',
  'pages.superH.loadProgressFailed': '获取进度失败',
  'pages.superH.configId': '配置ID: {id}',
  'pages.superH.name': '配置名称',
  'pages.superH.sourceConfigs': '来源配置',
  'pages.superH.targetConfig': '目标配置',
  'pages.superH.loadPlatformConfigsFailed': '加载 {platform} 配置失败，请稍后重试',
  'pages.superH.noPlatformConfigTitle': '尚未找到 {platform} 配置',
  'pages.superH.noPlatformConfigDescription': '请先创建至少两个 {platform} 回传配置，分别用作来源和接收配置。',
  'pages.superH.platformSourcePlaceholder': '选择一个或多个 {platform} 配置作为来源',
  'pages.superH.platformTargetPlaceholder': '选择接收回传的 {platform} 配置',
  'pages.superH.collectClickRecords': '收集点击记录',
  'pages.superH.sendInterval': '发送间隔',
  'pages.superH.sendIntervalSeconds': '{interval}秒',
  'pages.superH.status': '状态',
  'pages.superH.statusRunning': '运行中',
  'pages.superH.statusStopped': '已停止',
  'pages.superH.actions': '操作',
  'pages.superH.start': '启动',
  'pages.superH.stop': '停止',
  'pages.superH.collectTtclid': '收集ttclid',
  'pages.superH.collect': '收集',
  'pages.superH.viewProgress': '查看进度',
  'pages.superH.progress': '进度',
  'pages.superH.deleteConfig': '删除配置',
  'pages.superH.deleteConfirmTitle': '确定要删除这个配置吗？',
  'pages.superH.deleteConfirmDescription':
    '删除后将无法恢复，相关ttclid数据也会被清除。',
  'pages.superH.confirm': '确定',
  'pages.superH.cancel': '取消',
  'pages.superH.title': '超级回传配置',
  'pages.superH.subtitle': '从来源配置收集回传数据，定时发送到目标配置',
  'pages.superH.createConfig': '新建配置',
  'pages.superH.headerTitle': '超级回传配置列表',
  'pages.superH.progressModalTitle': '执行进度详情',
  'pages.superH.executionProgress': '执行进度',
  'pages.superH.totalCount': '总数量',
  'pages.superH.executedCount': '已执行',
  'pages.superH.remainingCount': '剩余',
  'pages.superH.lastExecuteTime': '最后执行时间',
  'pages.superH.refreshProgress': '刷新进度',
  'pages.superH.editTitle': '编辑超级回传配置',
  'pages.superH.createTitle': '新建超级回传配置',
  'pages.superH.breadcrumbAdCallback': '广告回传',
  'pages.superH.breadcrumbList': '超级回传配置',
  'pages.superH.breadcrumbEdit': '编辑配置',
  'pages.superH.breadcrumbCreate': '新建配置',
  'pages.superH.back': '返回',
  'pages.superH.loading': '加载中...',
  'pages.superH.noTikTokConfigTitle': '尚未找到 TikTok 配置',
  'pages.superH.noTikTokConfigDescription':
    '请先在 TikTok 回传配置中创建至少一个配置后，再创建超级回传。',
  'pages.superH.configName': '配置名称',
  'pages.superH.configNameRequired': '请输入配置名称',
  'pages.superH.configNamePlaceholder': '给这条超级回传配置起一个名字',
  'pages.superH.remark': '备注说明',
  'pages.superH.remarkPlaceholder': '（可选）填写这条配置的备注信息',
  'pages.superH.sourceConfigsRequired': '请选择至少一个来源配置',
  'pages.superH.sourceConfigsPlaceholder':
    '选择一个或多个 TikTok 配置作为数据来源',
  'pages.superH.targetConfigRequired': '请选择目标配置',
  'pages.superH.targetConfigConflict': '目标配置不能与来源配置相同',
  'pages.superH.targetConfigPlaceholder': '选择要投放的目标 TikTok 配置',
  'pages.superH.sendIntervalLabel': '发送间隔（秒）',
  'pages.superH.sendIntervalRequired': '请输入发送间隔',
  'pages.superH.sendIntervalTooltip':
    '用于控制批量上报的频率，范围 30-120 秒',
  'pages.superH.sendIntervalPlaceholder': '默认 60 秒',
  'pages.superH.saveChanges': '保存修改',

  // External callback pages
  'pages.externalCallback.enabledSuccess': '已启用',
  'pages.externalCallback.disabledSuccess': '已禁用',
  'pages.externalCallback.operationFailed': '操作失败',
  'pages.externalCallback.deleteSuccess': '删除成功',
  'pages.externalCallback.deleteFailed': '删除失败',
  'pages.externalCallback.id': 'ID',
  'pages.externalCallback.name': '配置名称',
  'pages.externalCallback.platform': '平台',
  'pages.externalCallback.pixelId': 'Pixel ID',
  'pages.externalCallback.directAccess': '直投接入',
  'pages.externalCallback.configId': '配置ID',
  'pages.externalCallback.copyDirectCode': '复制直投代码',
  'pages.externalCallback.copySuccess': '复制成功',
  'pages.externalCallback.copyFailed': '复制失败',
  'pages.externalCallback.eventType': '事件类型',
  'pages.externalCallback.callbackRatio': '回传比例',
  'pages.externalCallback.ipDedup': 'IP去重',
  'pages.externalCallback.noDedup': '不去重',
  'pages.externalCallback.dedupHours': '{hours}小时',
  'pages.externalCallback.createdAt': '创建时间',
  'pages.externalCallback.status': '状态',
  'pages.externalCallback.actions': '操作',
  'pages.externalCallback.on': '启用',
  'pages.externalCallback.off': '禁用',
  'pages.externalCallback.stats': '统计',
  'pages.externalCallback.editConfig': '编辑配置',
  'pages.externalCallback.deleteConfig': '删除配置',
  'pages.externalCallback.deleteConfirmTitle': '确定要删除这个配置吗？',
  'pages.externalCallback.deleteConfirmDescription': '删除后将无法恢复。',
  'pages.externalCallback.confirm': '确定',
  'pages.externalCallback.cancel': '取消',
  'pages.externalCallback.title': '外部URL回传配置',
  'pages.externalCallback.domainConfig': '域名配置',
  'pages.externalCallback.createConfig': '新建配置',
  'pages.externalCallback.headerTitle': '外部回传配置列表',
  'pages.externalCallback.searchConfigName': '搜索配置名称',
  'pages.externalCallback.search': '搜索',
  'pages.externalCallback.loadConfigFailed': '加载配置失败',
  'pages.externalCallback.updateSuccess': '更新成功',
  'pages.externalCallback.createSuccess': '创建成功',
  'pages.externalCallback.submitFailed': '提交失败',
  'pages.externalCallback.editTitle': '编辑外部回传配置',
  'pages.externalCallback.createTitle': '新建外部回传配置',
  'pages.externalCallback.back': '返回',
  'pages.externalCallback.save': '保存',
  'pages.externalCallback.introTitle': '外部URL回传说明',
  'pages.externalCallback.introDescription':
    '此配置用于外部URL斗篷功能。客户使用自己的外部落地页，通过JS SDK调用回传接口，系统会自动回传到对应的广告平台。',
  'pages.externalCallback.configName': '配置名称',
  'pages.externalCallback.configNameRequired': '请输入配置名称',
  'pages.externalCallback.configNamePlaceholder': '例如：TikTok-美国市场',
  'pages.externalCallback.remark': '备注',
  'pages.externalCallback.remarkPlaceholder': '配置说明（可选）',
  'pages.externalCallback.platformRequired': '请选择广告平台',
  'pages.externalCallback.platformPlaceholder': '请选择广告平台',
  'pages.externalCallback.pixelIdRequired': '请输入Pixel ID',
  'pages.externalCallback.pixelIdPlaceholder': '广告平台的像素ID',
  'pages.externalCallback.accessToken': 'Access Token',
  'pages.externalCallback.accessTokenRequired': '请输入Access Token',
  'pages.externalCallback.accessTokenPlaceholder': '广告平台的访问令牌',
  'pages.externalCallback.eventTypeRequired': '请选择事件类型',
  'pages.externalCallback.eventTypePlaceholder': '请选择事件类型',
  'pages.externalCallback.selectPlatformFirst': '请先选择广告平台',
  'pages.externalCallback.clientCustomEvent': '客户代码传入事件',
  'pages.externalCallback.callbackRatioRequired': '请设置回传比例',
  'pages.externalCallback.callbackRatioHelp':
    '设置回传的百分比，100表示全部回传，50表示50%概率回传，0表示不回传',
  'pages.externalCallback.defaultValue': '默认金额',
  'pages.externalCallback.defaultValueRequired': '请输入默认金额',
  'pages.externalCallback.defaultValueHelp':
    '当JS SDK调用时未传入金额时使用此默认值',
  'pages.externalCallback.defaultCurrency': '默认币种',
  'pages.externalCallback.defaultCurrencyRequired': '请选择默认币种',
  'pages.externalCallback.defaultCurrencyPlaceholder': '请选择币种',
  'pages.externalCallback.enableDedup': 'IP去重',
  'pages.externalCallback.statsTitle': '回传统计 - {name}',
  'pages.externalCallback.backToList': '返回列表',
  'pages.externalCallback.loadConfigInfoFailed': '加载配置信息失败',
  'pages.externalCallback.loadStatsFailed': '加载统计数据失败',
  'pages.externalCallback.event': '事件',
  'pages.externalCallback.success': '成功',
  'pages.externalCallback.failed': '失败',
  'pages.externalCallback.ip': 'IP',
  'pages.externalCallback.requestId': '请求ID',
  'pages.externalCallback.time': '时间',
  'pages.externalCallback.totalCallbacks': '总回传次数',
  'pages.externalCallback.successCount': '成功次数',
  'pages.externalCallback.failedCount': '失败次数',
  'pages.externalCallback.successRate': '成功率',
  'pages.externalCallback.dateRange': '日期范围：',
  'pages.externalCallback.query': '查询',
  'pages.externalCallback.totalRecords': '共 {total} 条记录',

  // Landing page list
  'pages.landingPageList.loadDomainsFailed': '加载域名配置失败',
  'pages.landingPageList.accessCodeMissing': '访问码不存在',
  'pages.landingPageList.domainConfigMissing': '域名配置未加载，请稍后重试',
  'pages.landingPageList.linkCopied': '链接已复制到剪贴板！',
  'pages.landingPageList.unknownError': '未知错误',
  'pages.landingPageList.copyLinkFailed': '复制失败: {message}',
  'pages.landingPageList.copySuccess': '复制成功！',
  'pages.landingPageList.copyFailed': '复制失败：{message}',
  'pages.landingPageList.copyFailedShort': '复制失败',
  'pages.landingPageList.deleteSuccess': '删除成功！',
  'pages.landingPageList.deleteFailed': '删除失败：{message}',
  'pages.landingPageList.deleteFailedShort': '删除失败',
  'pages.landingPageList.batchDelete': '批量删除',
  'pages.landingPageList.batchDeleteWithCount': '批量删除 ({count})',
  'pages.landingPageList.batchDeleteEmpty': '请先选择要删除的落地页',
  'pages.landingPageList.batchDeleteConfirmTitle':
    '确定要删除选中的 {count} 个落地页吗？',
  'pages.landingPageList.batchDeleteConfirmContent':
    '删除后无法恢复，已发布链接也将无法继续访问。',
  'pages.landingPageList.batchDeleteSuccess': '已删除 {count} 个落地页',
  'pages.landingPageList.batchDeleteFailed': '批量删除失败：{message}',
  'pages.landingPageList.batchDeleteFailedShort': '批量删除失败',
  'pages.landingPageList.publishSuccess': '发布成功！',
  'pages.landingPageList.publishCancelled': '已取消发布！',
  'pages.landingPageList.publishFailed': '发布失败：{message}',
  'pages.landingPageList.operationFailed': '操作失败：{message}',
  'pages.landingPageList.operationFailedShort': '操作失败',
  'pages.landingPageList.accessCodeGenerated':
    '访问码生成成功，请刷新页面后再次复制',
  'pages.landingPageList.accessCodeGenerateFailed': '访问码生成失败：{message}',
  'pages.landingPageList.accessCodeGenerateRetry':
    '访问码生成失败，请稍后重试',
  'pages.landingPageList.preview': '预览',
  'pages.landingPageList.noImage': '无图',
  'pages.landingPageList.page': '落地页',
  'pages.landingPageList.identifier': '标识',
  'pages.landingPageList.status': '状态',
  'pages.landingPageList.published': '已发布',
  'pages.landingPageList.draft': '草稿',
  'pages.landingPageList.createdAt': '创建时间',
  'pages.landingPageList.actions': '操作',
  'pages.landingPageList.publish': '发布',
  'pages.landingPageList.unpublish': '取消发布',
  'pages.landingPageList.copyLink': '复制链接',
  'pages.landingPageList.more': '更多',
  'pages.landingPageList.edit': '编辑',
  'pages.landingPageList.copyLandingPage': '复制落地页',
  'pages.landingPageList.generateQr': '生成二维码',
  'pages.landingPageList.delete': '删除',
  'pages.landingPageList.deleteConfirmTitle': '确定要删除这个落地页吗？',
  'pages.landingPageList.deleteConfirmContent': '删除后无法恢复',
  'pages.landingPageList.confirm': '确定',
  'pages.landingPageList.cancel': '取消',
  'pages.landingPageList.title': '落地页列表',
  'pages.landingPageList.searchPlaceholder': '搜索页面标题或短码',
  'pages.landingPageList.viewStats': '访问统计',
  'pages.landingPageList.createPage': '创建新页面',
  'pages.landingPageList.totalRecords': '共 {total} 条',

  // Form management
  'pages.formManagement.loadLandingPagesFailed': '加载落地页列表失败',
  'pages.formManagement.loadFailed': '加载失败：{message}',
  'pages.formManagement.loadRetry': '加载失败，请稍后重试',
  'pages.formManagement.deleteSuccess': '删除成功',
  'pages.formManagement.deleteFailed': '删除失败：{message}',
  'pages.formManagement.deleteRetry': '删除失败，请稍后重试',
  'pages.formManagement.exportSuccess': '导出成功',
  'pages.formManagement.exportFailed': '导出失败：{message}',
  'pages.formManagement.selectLandingPageWarning': '请至少选择一个落地页',
  'pages.formManagement.shareLinkCreated': '分享链接创建成功',
  'pages.formManagement.shareLinkCreateFailed': '创建分享链接失败：{message}',
  'pages.formManagement.shareLinkCreateRetry': '创建分享链接失败，请稍后重试',
  'pages.formManagement.shareLinkCopied': '分享链接已复制到剪贴板',
  'pages.formManagement.copyRetry': '复制失败，请手动复制',
  'pages.formManagement.clearSuccess': '清空成功',
  'pages.formManagement.clearQueued': '清理任务已加入后台队列，页面可以继续操作',
  'pages.formManagement.clearSuccessWithCount': '清空完成，共删除 {count} 条表单记录',
  'pages.formManagement.clearTimeout': '清理仍在后台执行，请稍后刷新查看',
  'pages.formManagement.clearFailed': '清空失败：{message}',
  'pages.formManagement.clearRetry': '清空失败，请稍后重试',
  'pages.formManagement.manualCallbackSuccess': '回传成功',
  'pages.formManagement.manualCallbackFailed': '回传失败：{message}',
  'pages.formManagement.manualCallbackRetry': '回传失败，请稍后重试',
  'pages.formManagement.unnamedSku': '未命名SKU',
  'pages.formManagement.title': '表单管理',
  'pages.formManagement.aiLandingPage': 'AI落地页',
  'pages.formManagement.pageType': '落地页类型',
  'pages.formManagement.allPageTypes': '全部类型',
  'pages.formManagement.builderLandingPage': '普通落地页',
  'pages.formManagement.clearIgnoresFilters': '清空范围为当前账号全部表单，不受筛选条件影响。',
  'pages.formManagement.range.all': '全部',
  'pages.formManagement.range.today': '今日',
  'pages.formManagement.range.7d': '近7天',
  'pages.formManagement.range.30d': '近30天',
  'pages.formManagement.selectLandingPage': '选择落地页',
  'pages.formManagement.allLandingPages': '全部落地页',
  'pages.formManagement.shareForm': '分享表单',
  'pages.formManagement.exportCsv': '导出CSV',
  'pages.formManagement.clearForm': '清空表单',
  'pages.formManagement.clearConfirmTitle': '确定要清空所有表单记录吗？',
  'pages.formManagement.clearConfirmDescription':
    '此操作不可恢复，将永久删除所有表单提交记录',
  'pages.formManagement.clearConfirmOk': '确定清空',
  'pages.formManagement.refresh': '刷新',
  'pages.formManagement.monthlyForms': '本月表单',
  'pages.formManagement.dailyForms': '当日表单',
  'pages.formManagement.uniqueUv': '独立UV',
  'pages.formManagement.submitTime': '提交时间',
  'pages.formManagement.urlSource': 'URL来源',
  'pages.formManagement.directVisit': '直接访问',
  'pages.formManagement.location': '地理位置',
  'pages.formManagement.unknown': '未知',
  'pages.formManagement.sku': 'SKU',
  'pages.formManagement.callbackStatus': '回传状态',
  'pages.formManagement.callback.pending': '待回传',
  'pages.formManagement.callback.success': '已回传',
  'pages.formManagement.callback.failed': '回传失败',
  'pages.formManagement.callback.skipped': '自动',
  'pages.formManagement.actions': '操作',
  'pages.formManagement.view': '查看',
  'pages.formManagement.manualCallback': '回传',
  'pages.formManagement.manualCallbackConfirm': '确定要手动回传吗？',
  'pages.formManagement.delete': '删除',
  'pages.formManagement.deleteConfirm': '确定要删除这条记录吗？',
  'pages.formManagement.totalRecords': '共 {total} 条记录',
  'pages.formManagement.detailTitle': '表单详情',
  'pages.formManagement.close': '关闭',
  'pages.formManagement.landingPage': '落地页',
  'pages.formManagement.pageId': '页面ID: {id}',
  'pages.formManagement.ipAddress': 'IP地址',
  'pages.formManagement.device': '设备',
  'pages.formManagement.formData': '表单数据',
  'pages.formManagement.shareTitle': '分享表单数据',
  'pages.formManagement.selectPagesToShare': '选择要分享的落地页：',
  'pages.formManagement.createShareLink': '生成分享链接',
  'pages.formManagement.shareLink': '分享链接：',
  'pages.formManagement.copy': '复制',
  'pages.formManagement.shareHint':
    '此链接可直接访问，无需登录。任何拥有此链接的人都可以查看选中落地页的表单数据。',
  'pages.formManagement.unknownDevice': '未知设备',
  'pages.formManagement.device.androidPhone': 'Android 手机',
  'pages.formManagement.device.androidTablet': 'Android 平板',

  'pages.landingPageStats.dataCenter': '数据中心',
  'pages.landingPageStats.dataCenterHint': '命中系统参数配置中的机房 IP/CIDR 列表',
  'pages.landingPageStats.visitsSubtitle': '按访问时间展示每一条记录，支持筛选单个落地页',
  'pages.landingPageStats.filterPage': '筛选落地页',
  'pages.landingPageStats.filterPagePlaceholder': '全部落地页 · 搜索标题或 ID',
  'pages.landingPageStats.loadingPages': '正在加载落地页…',
  'pages.landingPageStats.narrowPageSearch': '仅显示前50个匹配项，请输入更具体的标题或 ID',
  'pages.landingPageStats.loadPagesFailed': '落地页选项加载失败',
  'pages.landingPageStats.filterThisPage': '仅查看此落地页的访问',
  'pages.landingPageStats.duration': '停留时长',
  'pages.landingPageStats.durationSeconds': '{seconds} 秒',
  'pages.landingPageStats.allPages': '查看全部落地页',
  'pages.landingPageStats.export': '导出',
  'pages.landingPageStats.exporting': '正在导出',
  'pages.landingPageStats.cancelExport': '取消导出',
  'pages.landingPageStats.exportPageHint': '先筛选一个落地页，即可导出 CSV',
  'pages.landingPageStats.exportScopeHint': '导出该落地页在所选时间内的全部访问记录（CSV）',
  'pages.landingPageStats.exportFailed': '导出失败：{message}',
  'pages.landingPageStats.exportInvalidResponse': '导出文件无效，请重试',
  'pages.landingPageStats.visitRecords': '访问记录',
  'pages.landingPageStats.visitsNewestFirst': '按访问时间从新到旧',
  'pages.landingPageStats.visitPageInfo': '第 {page} 页 · 本页 {count} 条',
  'pages.landingPageStats.pageSize': '每页条数',
  'pages.landingPageStats.rowsPerPage': '{count} 条 / 页',
  'pages.landingPageStats.previousPage': '上一页',
  'pages.landingPageStats.nextPage': '下一页',
  'pages.landingPageStats.subtitle': '按日期查看访问数据，普通落地页与 AI 落地页独立统计',
  'pages.landingPageStats.regularPages': '普通落地页',
  'pages.landingPageStats.aiPages': 'AI 落地页',
  'pages.landingPageStats.today': '今日',
  'pages.landingPageStats.yesterday': '昨日',
  'pages.landingPageStats.last7Days': '近7天',
  'pages.landingPageStats.dateHint': '按系统时区统计，近7天包含今日',
  'pages.landingPageStats.retry': '重试',
  'pages.landingPageStats.pv': '浏览量（PV）',
  'pages.landingPageStats.uv': '访客数（UV）',
  'pages.landingPageStats.uniqueIp': '独立 IP',
  'pages.landingPageStats.uvHint': '按日期、路由和 IP 去重；近7天 UV 为每日访客数累计。',
  'pages.landingPageStats.pageCount': '当前类型落地页总数',
  'pages.landingPageStats.visiblePv': '本页浏览量（PV）',
  'pages.landingPageStats.visibleUv': '本页访客数（UV）',
  'pages.landingPageStats.newestFirst': '按落地页 ID 从新到旧',
  'pages.landingPageStats.visibleHint': '上方 PV / UV 为当前列表页内各落地页的合计，随翻页变化；同一访客访问多个落地页会分别计数。',
  'pages.landingPageStats.noPages': '暂无此类型的落地页',
  'pages.landingPageStats.noVisits': '所选时间范围内暂无访问记录',
  'pages.landingPageStats.visitedAt': '访问时间',
  'pages.landingPageStats.routeCode': '路由代码',
  'pages.landingPageStats.visitStatus': '访问状态',
  'pages.landingPageStats.blocked': '已拦截',
  'pages.landingPageStats.visited': '已访问',
  'pages.landingPageStats.detailRangeHint': '仅显示当前时间范围内的访问记录',
  'pages.landingPageStats.mobile': '手机',
  'pages.landingPageStats.desktop': '电脑',
  'pages.landingPageStats.title': '落地页访问统计',
  'pages.landingPageStats.refresh': '刷新',
  'pages.landingPageStats.monthlyPv': '近7天PV',
  'pages.landingPageStats.monthlyUv': '近7天UV',
  'pages.landingPageStats.todayUv': '当日访问UV',
  'pages.landingPageStats.recentDevices': '近7天访问设备（Top 5）',
  'pages.landingPageStats.recentCountries': '近7天访问国家（Top 5）',
  'pages.landingPageStats.noData': '暂无数据',
  'pages.landingPageStats.landingPageTitle': '落地页标题',
  'pages.landingPageStats.tableUv': '近7天UV',
  'pages.landingPageStats.tablePv': '近7天PV',
  'pages.landingPageStats.pageId': 'ID: {id}',
  'pages.landingPageStats.lastVisit': '最后访问',
  'pages.landingPageStats.actions': '操作',
  'pages.landingPageStats.details': '详情',
  'pages.landingPageStats.ipAddress': 'IP地址',
  'pages.landingPageStats.location': '地区',
  'pages.landingPageStats.unknown': '未知',
  'pages.landingPageStats.source': '来源',
  'pages.landingPageStats.visitDate': '访问日期',
  'pages.landingPageStats.visitTime': '访问时间',
  'pages.landingPageStats.device': '设备',
  'pages.landingPageStats.totalRecords': '共 {total} 条',
  'pages.landingPageStats.detailTitle': '访问详情 - {title}',
  'pages.landingPageStats.rangeStats': '查看日期范围统计',
  'pages.landingPageStats.loadSummaryFailed': '加载统计汇总失败：{message}',
  'pages.landingPageStats.loadDetailFailed': '加载访问详情失败：{message}',
  'pages.landingPageStats.loadRangeFailed': '加载日期范围统计失败：{message}',
  'pages.landingPageStats.loadRetry': '加载失败，请稍后重试',
  'pages.landingPageStats.unknownError': '未知错误',

  'pages.landingPageTemplates.status.draft': '草稿',
  'pages.landingPageTemplates.status.published': '已发布',
  'pages.landingPageTemplates.loadBaseUrlRetry':
    '加载落地页域名失败，请检查系统域名配置',
  'pages.landingPageTemplates.fetchDataFailed': '未能获取模板数据',
  'pages.landingPageTemplates.loadTemplatesRetry': '获取模板失败，请稍后再试',
  'pages.landingPageTemplates.loadLandingPagesFailed': '获取落地页列表失败',
  'pages.landingPageTemplates.updateSuccess': '模板更新成功',
  'pages.landingPageTemplates.createSuccess': '模板创建成功',
  'pages.landingPageTemplates.deleteSuccess': '删除成功',
  'pages.landingPageTemplates.deleteConfirmTitle':
    '确认删除模板「{title}」吗？',
  'pages.landingPageTemplates.copyTitle': '{title}-复制',
  'pages.landingPageTemplates.copySuccess': '模板复制成功',
  'pages.landingPageTemplates.copyFailed': '复制模板失败',
  'pages.landingPageTemplates.copyRetry': '复制模板失败，请稍后重试',
  'pages.landingPageTemplates.permissionDenied': '当前权限不足',
  'pages.landingPageTemplates.previewFrameTitle': '预览: {id}',
  'pages.landingPageTemplates.noPreview': '暂无预览',
  'pages.landingPageTemplates.domainNotConfigured': '落地页域名未配置',
  'pages.landingPageTemplates.previewDomainError':
    '落地页域名未配置，请联系管理员',
  'pages.landingPageTemplates.previewUnavailable': '该模板暂无预览',
  'pages.landingPageTemplates.copyTemplate': '复制模板',
  'pages.landingPageTemplates.previewTemplate': '预览模板',
  'pages.landingPageTemplates.editTemplate': '编辑模板信息',
  'pages.landingPageTemplates.deleteTemplate': '删除模板',
  'pages.landingPageTemplates.copy': '复制',
  'pages.landingPageTemplates.preview': '预览',
  'pages.landingPageTemplates.edit': '编辑',
  'pages.landingPageTemplates.delete': '删除',
  'pages.landingPageTemplates.createCustomTemplate': '新建自定义模板',
  'pages.landingPageTemplates.loading': '加载模板中...',
  'pages.landingPageTemplates.empty': '暂无模板，稍后再试',
  'pages.landingPageTemplates.latestTitle': '最新模版',
  'pages.landingPageTemplates.latestSubtitle': '发现近期上新的优质落地页设计',
  'pages.landingPageTemplates.aiExamples': 'AI落地页案例',
  'pages.landingPageTemplates.aiExamplesSubtitle': '一键复制 AI 生成的页面创意',
  'pages.landingPageTemplates.emptyAIExamples': '暂无AI落地页案例',
  'pages.landingPageTemplates.usageTip':
    '使用说明：模版库的落地页样式您都可以直接复制使用，并且模版库有的样式都是可以通过创建落地页的组件进行微调，DIY直到满意为止。',
  'pages.landingPageTemplates.allTemplates': '📋 全部模板',
  'pages.landingPageTemplates.refresh': '刷新',
  'pages.landingPageTemplates.editTitle': '编辑模板',
  'pages.landingPageTemplates.createTitle': '创建模板',
  'pages.landingPageTemplates.save': '保存',
  'pages.landingPageTemplates.create': '创建',
  'pages.landingPageTemplates.cancel': '取消',
  'pages.landingPageTemplates.sourceLandingPage': '来源落地页',
  'pages.landingPageTemplates.sourceLandingPageRequired': '请选择来源落地页',
  'pages.landingPageTemplates.sourceLandingPagePlaceholder':
    '选择一个已经创建好的落地页',
  'pages.landingPageTemplates.templateName': '模板名称',
  'pages.landingPageTemplates.templateNameRequired': '请输入模板名称',
  'pages.landingPageTemplates.templateNamePlaceholder':
    '例如：黑五电商模板',
  'pages.landingPageTemplates.templateDescription': '模板描述',
  'pages.landingPageTemplates.templateDescriptionPlaceholder':
    '模板介绍或适用场景',
  'pages.landingPageTemplates.tags': '标签',
  'pages.landingPageTemplates.tagsPlaceholder': '输入后按回车添加标签',
  'pages.landingPageTemplates.minVipLevel': '最低VIP等级',
  'pages.landingPageTemplates.minVipLevelRequired': '请选择VIP等级',
  'pages.landingPageTemplates.vipPlaceholder': '选择VIP权限',
  'pages.landingPageTemplates.status': '状态',
  'pages.landingPageTemplates.applyTitle': '复制模板生成落地页',
  'pages.landingPageTemplates.generateLandingPage': '生成落地页',
  'pages.landingPageTemplates.newLandingPageName': '新落地页名称',
  'pages.landingPageTemplates.nameRequired': '请输入名称',
  'pages.landingPageTemplates.newLandingPageNamePlaceholder':
    '例如：黑五电商模板-我的版本',
  'pages.landingPageTemplates.landingPageDescription': '落地页描述',
  'pages.landingPageTemplates.landingPageDescriptionPlaceholder':
    '可选，方便记忆此落地页用途',
  'pages.landingPageTemplates.groupName': '分组名称',
  'pages.landingPageTemplates.groupNamePlaceholder': '用于落地页分组管理',
  'pages.landingPageTemplates.groupColor': '分组颜色',
  'pages.landingPageTemplates.groupColorPlaceholder': '例如：#1890FF',
  'pages.landingPageTemplates.seoTitle': 'SEO标题',
  'pages.landingPageTemplates.seoTitlePlaceholder':
    '可覆盖模板的默认SEO标题',
  'pages.landingPageTemplates.seoDescription': 'SEO描述',
  'pages.landingPageTemplates.seoDescriptionPlaceholder':
    '可覆盖模板的默认SEO描述',
  'pages.landingPageTemplates.seoKeywords': 'SEO关键词',
  'pages.landingPageTemplates.seoKeywordsPlaceholder':
    '多个关键词用逗号隔开',
  'pages.landingPageTemplates.customCode': '自定义代码',
  'pages.landingPageTemplates.customCodePlaceholder':
    '可放广告像素或自定义脚本',

  // 加载界面
  'pages.loading.title': '正在加载资源',
  'pages.loading.subtitle': '初次加载资源可能需要较多时间 请耐心等待',

  // 修改密码页面
  'pages.changePassword.title': '修改密码',
  'pages.changePassword.oldPassword.placeholder': '请输入原密码',
  'pages.changePassword.oldPassword.required': '请输入原密码!',
  'pages.changePassword.newPassword.placeholder': '请输入新密码',
  'pages.changePassword.newPassword.required': '请输入新密码！',
  'pages.changePassword.newPassword.length': '密码长度至少6个字符！',
  'pages.changePassword.confirmPassword.placeholder': '请确认新密码',
  'pages.changePassword.confirmPassword.required': '请确认新密码！',
  'pages.changePassword.backToHome': '返回首页',
};
